(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brand-products').forEach((root) => {
    const track = root.querySelector('.brand-products__track');
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    if (!track || !prev || !next) return;

    const slides = Array.from(track.querySelectorAll('.brand-products__slide'));
    if (!slides.length) return;

    /* Filtros por categoria. Uno solo activo a la vez: es una vista del mismo
       carrusel, no una seleccion multiple — con dos activos el usuario deja de
       saber que esta viendo. Se ocultan slides en vez de repintar la lista para
       que el scroll-snap y las flechas sigan siendo los mismos. */
    const filtros = root.querySelector('[data-product-filters]');
    if (filtros) {
      const chips = Array.from(filtros.querySelectorAll('.chip'));

      /* «Otros» no es una coleccion: es TODO lo que no cae en los otros
         cajones. Se resuelve por descarte y no con una lista, para que un
         producto nuevo aparezca ahi solo, sin tocar nada. */
      const CAJONES = ['granolas', 'fruit-bites'];
      const aplicar = (handle) => {
        slides.forEach((slide) => {
          const suyas = (slide.dataset.collections || '').split(' ');
          let dentro;
          if (handle === 'all') dentro = true;
          else if (handle === 'otros') dentro = !CAJONES.some((c) => suyas.includes(c));
          else dentro = suyas.includes(handle);
          slide.hidden = !dentro;
        });
      };

      /* El cajon preseleccionado se aplica al cargar: si solo se pintara el
         chip como activo, la vista y el control dirian cosas distintas. */
      const inicial = filtros.dataset.defaultFilter;
      if (inicial && inicial !== 'all') aplicar(inicial);
      filtros.addEventListener('click', (e) => {
        const chip = e.target.closest('.chip');
        if (!chip) return;
        const handle = chip.dataset.filter;
        chips.forEach((c) => {
          const activo = c === chip;
          c.classList.toggle('is-active', activo);
          c.setAttribute('aria-pressed', activo ? 'true' : 'false');
        });
        aplicar(handle);
        /* Al filtrar, el carrusel vuelve al principio: si no, la vista nueva
           empieza donde acababa la anterior y parece vacia. */
        track.scrollTo({ left: 0, behavior: 'smooth' });
      });
    }

    const step = (dir) => {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: dir * (slides[0].offsetWidth + gap), behavior: 'smooth' });
    };
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));

    /* Arrastre con el raton en desktop. El track ya es un scroll horizontal, asi
       que arrastrar es mover su `scrollLeft`: no hace falta reimplementar
       inercia ni transformar nada, y el snap, las flechas y el teclado siguen
       operando sobre la misma propiedad. */
    let arrastre = null;
    const UMBRAL = 4;

    track.addEventListener('pointerdown', (e) => {
      /* Solo raton: en tactil el scroll nativo ya lo hace, y capturar el puntero
         alli rompe el desplazamiento con inercia del sistema. */
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrastre = { x: e.clientX, desde: track.scrollLeft, recorrido: 0 };
    });

    track.addEventListener('pointermove', (e) => {
      if (!arrastre) return;
      const dx = e.clientX - arrastre.x;
      arrastre.recorrido = Math.max(arrastre.recorrido, Math.abs(dx));
      /* ⚠️ El umbral no es cosmetico: sin el, cualquier temblor al hacer clic en
         una card se lleva el puntero y el enlace no llega a abrirse. Hasta que
         no hay recorrido de verdad, esto no es un arrastre. */
      if (arrastre.recorrido <= UMBRAL) return;
      if (!track.classList.contains('is-dragging')) {
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      }
      e.preventDefault();
      track.scrollLeft = arrastre.desde - dx;
    });

    const soltar = (e) => {
      if (!arrastre) return;
      const hubeArrastrado = arrastre.recorrido > UMBRAL;
      arrastre = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      /* ⚠️ Soltar sobre una card NO debe abrirla: el `click` se dispara igual
         despues del `pointerup`. Se bloquea solo ese, y el listener se retira en
         el tick siguiente para no comerse el clic legitimo de despues. */
      if (!hubeArrastrado) return;
      const tragarClick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
      };
      track.addEventListener('click', tragarClick, true);
      setTimeout(() => track.removeEventListener('click', tragarClick, true), 0);
    };

    track.addEventListener('pointerup', soltar);
    track.addEventListener('pointercancel', soltar);

    let raf = null;
    const sync = () => {
      raf = null;
      prev.toggleAttribute('disabled', track.scrollLeft < 40);
      next.toggleAttribute(
        'disabled',
        track.scrollLeft > track.scrollWidth - track.clientWidth - 40
      );

      const center = track.scrollLeft + track.clientWidth / 2;
      let closest = null;
      let closestDist = Infinity;
      slides.forEach((slide) => {
        const dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = slide;
        }
      });
      slides.forEach((slide) => slide.classList.toggle('is-center', slide === closest));
    };
    const requestSync = () => {
      if (raf === null) raf = requestAnimationFrame(sync);
    };
    track.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    sync();

    /* ⚠️ NO SE TOCA EL SCROLL AL ARRANCAR. Antes empezaba desplazado una card
       para centrar la segunda «como el Figma»; con la fila alineada al margen
       eso cortaria la primera por la izquierda y devolveria la sensacion de
       hueco. La composicion del Figma se conserva igual: a 1440 la segunda es
       la que cae bajo el centro del viewport, asi que es la que recibe el
       realce sin mover nada. */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-talent"] && !Shopify.designMode) return;
  try {
    
  // Lo unico que necesita JS: ensenar el nombre del fichero elegido. El input
  // nativo no se puede maquetar, asi que la etiqueta tiene que contarlo.
  document.querySelectorAll('.brand-talent__file').forEach(function (label) {
    var input = label.querySelector('input[type="file"]');
    var out = label.querySelector('[data-file-name]');
    if (!input || !out) return;
    var hint = out.textContent;
    input.addEventListener('change', function () {
      out.textContent = input.files.length ? input.files[0].name : hint;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-testimonials"] && !Shopify.designMode) return;
  try {
    
  /* ⭐ RESEÑAS DE OKENDO (Guille, 02/10). Con el ID de Okendo, el carrusel se
     alimenta de su API publica (CORS abierto): las mas recientes con nota
     minima (4 por defecto: si no, no tiene sentido destacarlas) y una
     longitud que quepa en la cita gigante. Las citas escritas en los blocks
     quedan de reserva: si la API no responde o no hay ninguna que pase el
     filtro, se ven esas. El texto entra por textContent: nada de HTML ajeno. */
  const okendoReviews = async (root) => {
    const id = encodeURIComponent(root.dataset.okendo);
    const min = Number(root.dataset.okendoMinRating) || 4;
    const count = Number(root.dataset.okendoCount) || 6;
    const minLen = Number(root.dataset.okendoMinLength) || 0;
    const maxLen = Number(root.dataset.okendoMaxLength) || 999;
    const base = 'https://api.okendo.io/v1';
    const get = async (path) => {
      const response = await fetch(base + path);
      if (!response.ok) throw new Error('okendo ' + response.status);
      return response.json();
    };
    const good = (list) => list
      .filter((r) => r.status === 'approved' && r.rating >= min)
      .map((r) => ({ ...r, text: (r.body || '').replace(/\s+/g, ' ').trim() }))
      .filter((r) => r.text.length >= minLen && r.text.length <= maxLen)
      /* ⭐ Primero las de MÁS NOTA (Guille, 03/10): 5, luego 4,5, luego 4. Okendo
         da la nota de cada reseña en enteros, así que en la práctica es 5 → 4;
         si algún día llegan medias, el orden ya las contempla. Dentro de cada
         nota se respeta el orden de la API: las más recientes primero. */
      .sort((a, b) => b.rating - a.rating);

    /* ⭐ EN LA FICHA (modo producto): primero las de ESE producto; si no hay,
       las de su categoria (los productos de sus colecciones); si tampoco, las
       generales (Guille, 02/10). Se cruza por HANDLE, que es el mismo en la
       tienda real y en la de desarrollo; el ID solo vale en la real. */
    const handle = root.dataset.okendoProduct;
    if (handle) {
      try {
        const own = await get(`/stores/${id}/products/shopify-${root.dataset.okendoProductId}/reviews?limit=50&orderBy=date%20desc`);
        const mine = good(own.reviews || []);
        if (mine.length) return mine.slice(0, count);
      } catch (e) { /* el ID no existe en esta tienda: se sigue por handle */ }
    }
    let all = [];
    let path = `/stores/${id}/reviews?limit=100&orderBy=date%20desc`;
    for (let page = 0; page < (handle ? 3 : 1) && path; page++) {
      const data = await get(path);
      all = all.concat(data.reviews || []);
      path = data.nextUrl || null;
    }
    const pool = good(all);
    if (handle) {
      const mine = pool.filter((r) => r.productHandle === handle);
      if (mine.length) return mine.slice(0, count);
      const category = (root.dataset.okendoCategory || '').split(',').filter(Boolean);
      const near = pool.filter((r) => category.includes(r.productHandle));
      if (near.length) return near.slice(0, count);
    }
    return pool.slice(0, count);
  };

  const slide = (root, review) => {
    const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
    const wrap = el('div', 'brand-testimonials__slide');
    const figure = el('figure', 'testimonial-quote');
    figure.append(el('blockquote', 'testimonial-quote__text', '\u201C' + review.text + '\u201D'));
    const cap = el('figcaption', 'testimonial-quote__author');
    cap.append(el('span', null, review.reviewer?.displayName || ''));
    if (review.productName) cap.append(el('span', 'brand-testimonials__product', review.productName));
    const stars = el('span', 'testimonial-quote__stars', '\u2605 '.repeat(review.rating).trim());
    stars.setAttribute('aria-hidden', 'true');
    cap.append(stars);
    cap.append(el('span', 'visually-hidden', (root.dataset.labelRating || '').replace('__N__', review.rating)));
    figure.append(cap);
    wrap.append(figure);
    return wrap;
  };

  const buildDots = (root, n) => {
    const holder = root.querySelector('[data-okendo-dots]');
    if (!holder || n < 2) return;
    const box = document.createElement('div');
    box.className = 'slider-dots';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', root.dataset.labelDots || '');
    box.dataset.sliderDots = '';
    for (let i = 0; i < n; i++) {
      const dot = document.createElement('button');
      dot.className = 'slider-dots__dot';
      dot.type = 'button';
      dot.dataset.index = String(i);
      dot.setAttribute('aria-label', `${root.dataset.labelDot || ''} ${i + 1} / ${n}`);
      if (i === 0) dot.setAttribute('aria-current', 'true');
      box.append(dot);
    }
    const pill = document.createElement('span');
    pill.className = 'slider-dots__pill';
    pill.setAttribute('aria-hidden', 'true');
    box.append(pill);
    holder.replaceWith(box);
  };

  const setup = (root) => {
    const track = root.querySelector('.brand-testimonials__track');
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    if (!track || !prev || !next) return;

    const step = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));

    /* Puntos: siguen a la cita visible y, al pulsarlos, llevan a la suya */
    const dotsBox = root.querySelector('[data-slider-dots]');
    const dots = dotsBox && window.LNYSliderDots ? window.LNYSliderDots.attach(dotsBox) : null;
    if (dotsBox) {
      dotsBox.addEventListener('slider-dots:select', (event) => {
        track.scrollTo({ left: event.detail.index * track.clientWidth, behavior: 'smooth' });
      });
    }
    let shownDot = 0;

    const sync = () => {
      const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (dots && i !== shownDot) { shownDot = i; dots.go(i); }
      prev.toggleAttribute('disabled', track.scrollLeft < 40);
      next.toggleAttribute(
        'disabled',
        track.scrollLeft > track.scrollWidth - track.clientWidth - 40
      );
    };
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  };

  document.querySelectorAll('.brand-testimonials').forEach((root) => {
    if (!root.dataset.okendo) { setup(root); return; }
    const track = root.querySelector('.brand-testimonials__track');
    okendoReviews(root)
      .then((reviews) => {
        if (!reviews.length) throw new Error('okendo: ninguna pasa el filtro');
        track.replaceChildren(...reviews.map((review) => slide(root, review)));
        buildDots(root, reviews.length);
      })
      .catch(() => buildDots(root, track.children.length))
      .finally(() => setup(root));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-cart-drawer]');
    if (!dialog) return;

    const cartPath = dialog.dataset.cartUrl;
    const content = () => dialog.querySelector('[data-cart-drawer-content]');
    const api = () => window.lnyCart;

    /* ---- Repintar: el HTML es el de esta seccion, tal cual lo da Shopify ---- */
    const paint = (html) => {
      const box = content();
      if (!html || !box) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
      if (!fresh) return;

      /* Lo que se perderia al cambiar el contenido: donde estaba el foco, por
         donde iba el scroll de las lineas y cuanto llevaba la barrita */
      const active = document.activeElement;
      const focusId = active && box.contains(active) ? active.dataset.focusId : '';
      const lines = box.querySelector('[data-cart-lines]');
      const scroll = lines ? lines.scrollTop : 0;
      const oldFill = box.querySelector('.shipping-bar__fill');
      const oldProgress = oldFill ? oldFill.style.getPropertyValue('--progress') : '';

      box.replaceChildren(...fresh.childNodes);

      const newLines = box.querySelector('[data-cart-lines]');
      if (newLines) newLines.scrollTop = scroll;

      const fill = box.querySelector('.shipping-bar__fill');
      if (fill && oldProgress) {
        const target = fill.style.getPropertyValue('--progress');
        fill.style.setProperty('--progress', oldProgress);
        void fill.offsetWidth;
        fill.style.setProperty('--progress', target);
      }

      syncShipping();

      if (focusId) {
        /* Si la linea ya no existe (se quito), el foco va al cierre: nunca se
           queda en el aire, que en un modal es perderlo */
        const next = [...box.querySelectorAll('[data-focus-id]')].find((el) => el.dataset.focusId === focusId);
        (next || box.querySelector('[data-cart-close]')).focus();
      }
    };

    /* ---- Envio ----
       El precio lo da Shopify; aqui solo se averigua la provincia, que es lo
       que exige para contestar. En Espana son las dos primeras cifras del
       codigo postal (01 Alava … 52 Melilla), en este orden. */
    const PROVINCES = 'VI AB A AL AV BA PM B BU CC CA CS CR CO C CU GI GR GU SS H HU J LE L LO LU M MA MU NA OR O P GC PO SA TF S SG SE SO T TE TO V VA BI ZA Z CE ML'.split(' ');
    const provinceOf = (zip) => (/^\d{5}$/.test(zip) ? PROVINCES[Number(zip.slice(0, 2)) - 1] : undefined);

    /* El codigo postal se recuerda entre visitas; si el navegador no deja
       guardar (modo privado), se pregunta otra vez y ya */
    const ZIP_KEY = 'lny-shipping-zip';
    const zipStore = {
      get() {
        try { return localStorage.getItem(ZIP_KEY) || ''; } catch (error) { return ''; }
      },
      set(zip) {
        try { zip ? localStorage.setItem(ZIP_KEY, zip) : localStorage.removeItem(ZIP_KEY); } catch (error) { /* sin memoria */ }
      },
    };

    const shippingBox = () => dialog.querySelector('[data-cart-shipping]');
    const part = (box, name) => box.querySelector('[data-shipping-' + name + ']');
    const rateJobs = new Map();
    let rateToken = 0;

    /* Pinta UNO de los estados del bloque: ask | loading | rates | none | error */
    const shippingState = (box, state, zip, rates) => {
      const data = box.dataset;
      const known = state !== 'ask';
      const note = { loading: data.loading, none: data.none, error: data.error, invalid: data.invalid }[state] || '';
      const policy = part(box, 'policy');

      part(box, 'title').textContent = known && zip ? data.to.replace('__ZIP__', zip) : data.label;
      part(box, 'change').hidden = !known || state === 'invalid';
      part(box, 'form').hidden = known && state !== 'invalid';
      part(box, 'note').textContent = note;
      part(box, 'note').hidden = !note;
      if (policy) policy.hidden = state !== 'none' && state !== 'error';

      const list = part(box, 'rates');
      list.hidden = state !== 'rates';
      list.replaceChildren(
        ...(state === 'rates' ? rates : []).map((rate) => {
          const item = document.createElement('li');
          const name = document.createElement('span');
          const price = document.createElement('span');
          item.className = 'cart-drawer__rate';
          price.className = 'cart-drawer__rate-price';
          name.textContent = rate.name;
          price.textContent =
            Number(rate.price) > 0
              ? new Intl.NumberFormat(data.locale, { style: 'currency', currency: rate.currency }).format(rate.price)
              : data.free;
          item.append(name, price);
          return item;
        })
      );
    };

    const estimate = (zip, moveFocus) => {
      const box = shippingBox();
      if (!box || !api()) return;
      const province = provinceOf(zip);
      if (!province) {
        shippingState(box, 'invalid');
        return;
      }
      zipStore.set(zip);

      /* La misma cesta al mismo destino cuesta lo mismo: no se vuelve a pedir */
      const key = zip + '|' + box.dataset.cartState;
      const token = (rateToken += 1);
      if (!rateJobs.has(key)) {
        shippingState(box, 'loading', zip);
        rateJobs.set(key, api().shippingRates(box.dataset.ratesUrl, { zip, country: 'Spain', province }));
      }
      rateJobs
        .get(key)
        .then((rates) => {
          /* Si entre tanto cambio la cesta o el codigo, esta respuesta ya no vale */
          const now = shippingBox();
          if (token !== rateToken || !now) return;
          const sorted = [...rates].sort((a, b) => Number(a.price) - Number(b.price));
          shippingState(now, sorted.length ? 'rates' : 'none', zip, sorted);
          if (moveFocus) part(now, 'change').focus();
        })
        .catch(() => {
          rateJobs.delete(key);
          const now = shippingBox();
          if (token === rateToken && now) shippingState(now, 'error', zip);
        });
    };

    /* Tras cada repintado el bloque vuelve vacio: si ya se sabe el destino,
       se recalcula con la cesta nueva */
    const syncShipping = () => {
      const zip = zipStore.get();
      if (zip) estimate(zip);
    };

    const submitZip = () => {
      const box = shippingBox();
      if (box) estimate(part(box, 'zip').value.trim(), true);
    };

    /* ---- Cantidades ----
       Cada pulsacion cambia el numero en el acto y la peticion espera un
       instante: tres toques seguidos al «mas» son UNA llamada con el total. */
    const WAIT_MS = 300;
    const timers = new Map();
    let chain = Promise.resolve();
    let inFlight = 0;

    const showError = (message) => {
      const box = dialog.querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = message || box.dataset.fallback;
      box.hidden = false;
    };

    const send = (key, quantity) => {
      const body = new FormData();
      body.append('id', key);
      body.append('quantity', quantity);
      inFlight += 1;
      chain = chain
        .then(() => api().request(dialog.dataset.changeUrl + '.js', body))
        .catch((error) =>
          /* Sin stock suficiente, sin red…: se vuelve a lo que diga Shopify y
             se cuenta el motivo. El aviso va DESPUES de repintar o se borraria. */
          api()
            .refresh()
            .catch(() => {})
            .then(() => showError(error && error.description))
        )
        .finally(() => {
          inFlight -= 1;
        });
    };

    const schedule = (key, quantity) => {
      clearTimeout(timers.get(key));
      timers.set(
        key,
        setTimeout(() => {
          timers.delete(key);
          send(key, quantity);
        }, WAIT_MS)
      );
    };

    const lineOf = (el) => el.closest('[data-cart-line]');
    const clean = (value) => Math.max(0, Math.floor(Number(value)) || 0);

    dialog.addEventListener('click', (event) => {
      /* Clic fuera del panel: lo que queda a su lado es el propio dialog */
      if (event.target === dialog || event.target.closest('[data-cart-close]')) {
        dialog.close();
        return;
      }
      if (!api()) return;

      if (event.target.closest('[data-shipping-calc]')) {
        submitZip();
        return;
      }
      if (event.target.closest('[data-shipping-change]')) {
        const box = shippingBox();
        rateToken += 1;
        shippingState(box, 'ask');
        part(box, 'zip').value = zipStore.get();
        part(box, 'zip').focus();
        return;
      }

      /* Sugerencias: añadir va por la misma via que cualquier formulario de
         producto, y la respuesta repinta el cajon (lo añadido sale de la
         lista y entra en las lineas) */
      const suggest = event.target.closest('[data-cart-suggest]');
      if (suggest) {
        if (suggest.getAttribute('aria-busy') === 'true') return;
        suggest.setAttribute('aria-busy', 'true');
        const body = new FormData();
        body.append('id', suggest.dataset.cartSuggest);
        body.append('quantity', 1);
        api()
          .request(dialog.dataset.addUrl + '.js', body)
          .catch((error) => {
            suggest.removeAttribute('aria-busy');
            showError(error && error.description);
          });
        return;
      }

      const step = event.target.closest('[data-cart-step]');
      if (step) {
        const line = lineOf(step);
        const input = line.querySelector('[data-cart-qty]');
        input.value = clean(Number(input.value) + Number(step.dataset.cartStep));
        schedule(line.dataset.cartLine, input.value);
        return;
      }

      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        schedule(remove.dataset.cartRemove, 0);
      }
    });

    dialog.addEventListener('change', (event) => {
      if (!api() || !event.target.matches('[data-cart-qty]')) return;
      event.target.value = clean(event.target.value);
      schedule(lineOf(event.target).dataset.cartLine, event.target.value);
    });

    /* Enter en el numero aplica la cantidad, y en el codigo postal calcula el
       envio; ninguno de los dos manda al checkout a medias */
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !api()) return;
      if (event.target.matches('[data-shipping-zip]')) {
        event.preventDefault();
        submitZip();
        return;
      }
      if (!event.target.matches('[data-cart-qty]')) return;
      event.preventDefault();
      event.target.blur();
      event.target.focus();
    });

    /* ---- Lo que llega de lny-cart-drawer.js y de lny-quick-buy.js ---- */
    document.addEventListener('lny:cart-updated', (event) => {
      /* Con cambios aun por enviar, repintar pisaria lo que el cliente acaba
         de teclear: pinta la ultima respuesta, que ya los trae todos */
      if (timers.size > 0 || inFlight > 1) return;
      const sections = event.detail && event.detail.sections;
      if (sections) paint(sections['cart-drawer']);
    });

    const open = () => {
      if (!dialog.open) dialog.showModal();
    };

    document.addEventListener('lny:cart-added', () => {
      if (dialog.dataset.openOnAdd === 'true') open();
    });

    /* ---- Abrir: cualquier enlace a la cesta abre el cajon ----
       Sigue siendo un enlace de verdad (sin JS, o en pestaña nueva, va a
       /cart); aqui solo se intercepta el clic normal. */
    const isCartLink = (link) =>
      link.target !== '_blank' && link.origin === window.location.origin && link.pathname === cartPath;

    document.querySelectorAll('a[href]').forEach((link) => {
      if (isCartLink(link)) link.setAttribute('aria-haspopup', 'dialog');
    });

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || dialog.contains(link) || !isCartLink(link)) return;
      event.preventDefault();
      open();
      /* La cesta pudo cambiar en otra pestaña: se abre con lo que hay y se
         pone al dia por detras */
      if (api()) api().refresh().catch(() => {});
    });

    syncShipping();

    /* Volver atras desde el checkout restaura la pagina tal como se dejo */
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && api()) api().refresh().catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-points"] && !Shopify.designMode) return;
  try {
    
  /* Selector de reseñas: dialog nativo (foco atrapado y Esc de serie); clic
     fuera del panel lo cierra; al cerrar, el foco vuelve al boton que lo abrio */
  document.querySelectorAll('.club-points').forEach((section) => {
    const dialog = section.querySelector('[data-review-picker]');
    if (!dialog) return;
    let opener = null;
    section.querySelectorAll('[data-review-open]').forEach((button) => {
      button.addEventListener('click', () => { opener = button; dialog.showModal(); });
    });
    dialog.querySelector('[data-review-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    const filters = [...dialog.querySelectorAll('[data-review-filter]')];
    filters.forEach((chip) => chip.addEventListener('click', () => {
      const kind = chip.dataset.reviewFilter;
      filters.forEach((other) => {
        other.classList.toggle('is-active', other === chip);
        other.setAttribute('aria-pressed', String(other === chip));
      });
      dialog.querySelectorAll('[data-kinds]').forEach((item) => {
        item.hidden = !!kind && !item.dataset.kinds.includes(',' + kind + ',');
      });
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-browse"] && !Shopify.designMode) return;
  try {
    
  // Filtro de catalogo: OR dentro de cada grupo, AND entre grupos — que es como
  // se comportan las facetas de cualquier tienda. Marcar «Granolas» y «Packs»
  // enseña las dos familias; marcar ademas «Ofertas» deja las de esas familias
  // que ademas esten rebajadas.
  document.querySelectorAll('[data-browse]').forEach((root) => {
    const grid = root.querySelector('[data-browse-grid]');
    if (!grid) return;

    const inputs = Array.from(root.querySelectorAll('[data-browse-filter]'));
    const cells = Array.from(grid.querySelectorAll('.product-grid__cell'));
    const count = root.querySelector('[data-browse-count]');
    const empty = root.querySelector('[data-browse-empty]');
    const clears = Array.from(root.querySelectorAll('[data-browse-clear]'));
    const plantilla = count ? count.textContent.trim() : '';

    const cumple = (cell, valores) =>
      valores.some((v) =>
        v === '__sale'
          ? cell.dataset.sale === 'true'
          : (cell.dataset.collections || '').split(' ').includes(v)
      );

    const aplicar = () => {
      const grupos = {};
      inputs.filter((i) => i.checked).forEach((i) => {
        (grupos[i.dataset.group] = grupos[i.dataset.group] || []).push(i.value);
      });
      const activos = Object.values(grupos);

      let visibles = 0;
      cells.forEach((cell) => {
        const ok = activos.every((valores) => cumple(cell, valores));
        cell.hidden = !ok;
        if (ok) visibles += 1;
      });

      if (count) {
        // El texto sale de la traduccion, asi que solo se sustituye el numero:
        // asi no hay una cadena escrita en el JS que se quede sin traducir.
        count.textContent = plantilla.replace(/\d+/, visibles);
      }
      if (empty) empty.hidden = visibles !== 0;
      clears.forEach((b) => {
        if (b.classList.contains('browse__clear')) b.hidden = activos.length === 0;
      });
    };

    inputs.forEach((i) => i.addEventListener('change', aplicar));
    clears.forEach((b) =>
      b.addEventListener('click', () => {
        inputs.forEach((i) => {
          i.checked = false;
        });
        aplicar();
      })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Foto de ambiente de las tarjetas con bodegon: se pide la primera vez que
     el raton pasa por la imagen (no en la carga de la pagina) */
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const alt = event.target.closest('.product-card__media')?.querySelector('.product-card__alt[data-src]');
    if (!alt) return;
    alt.addEventListener('load', () => alt.classList.add('is-loaded'), { once: true });
    alt.src = alt.dataset.src;
    alt.removeAttribute('data-src');
  });

  /* LA TIENDA: pestañas de familia + subfiltros. Una pestaña deja las celdas
     de sus colecciones; los subfiltros, dentro de ella, se combinan en Y
     (pulsar uno activo lo apaga). La pastilla se desliza a la
     pestaña activa. Las flechas del teclado cambian de pestaña (patron tablist). */
  document.querySelectorAll('[data-shop-filters]').forEach((filters) => {
    const page = filters.closest('.collection-page');
    const cells = [...page.querySelectorAll('.product-grid__cell')];
    const tabs = [...filters.querySelectorAll('[data-shop-tab]')];
    const pill = filters.querySelector('.pill-tabs__pill');
    let tabHandles = [];
    let chipHandles = null;

    const placePill = (tab) => {
      if (!pill || !tab) return;
      pill.style.setProperty('--pill-w', tab.offsetWidth + 'px');
      pill.style.setProperty('--pill-x', tab.offsetLeft + 'px');
    };
    const apply = () => {
      cells.forEach((cell) => {
        const mine = (cell.dataset.collections || '').split(' ');
        /* Una pestaña sin colecciones es «Todo»: no filtra por familia */
        const inTab = !tabHandles.length || tabHandles.some((h) => mine.includes(h));
        const show = inTab && (!chipHandles || chipHandles.includes(cell.dataset.handle));
        if (show && cell.hidden) {
          cell.classList.remove('is-entering');
          void cell.offsetWidth;
          cell.classList.add('is-entering');
        }
        cell.hidden = !show;
      });
      /* Ningún producto con los subfiltros encendidos: estado vacío con salida */
      const empty = page.querySelector('[data-filter-empty]');
      if (empty) empty.hidden = !chipHandles || cells.some((cell) => !cell.hidden);
    };
    const selectTab = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      tabHandles = (tab.dataset.handles || '').split(',').filter(Boolean);
      chipHandles = null;
      filters.querySelectorAll('[data-shop-chips]').forEach((row) => {
        row.hidden = row.dataset.shopChips !== tab.dataset.shopTab;
      });
      filters.querySelectorAll('[data-shop-chip]').forEach((chip) => {
        chip.classList.remove('is-active');
        chip.setAttribute('aria-pressed', 'false');
      });
      placePill(tab);
      if (focus) tab.focus();
      const row = filters.querySelector(`[data-shop-chips="${tab.dataset.shopTab}"]`);
      if (row) refreshChips(row);
      else { apply(); syncBadges([]); }
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        selectTab(tabs[(i + step + tabs.length) % tabs.length], true);
      });
    });
    const inCurrentTab = () => cells.filter((cell) => {
      const mine = (cell.dataset.collections || '').split(' ');
      return !tabHandles.length || tabHandles.some((h) => mine.includes(h));
    }).map((cell) => cell.dataset.handle);
    const listOf = (chip) => (chip.dataset.handles || '').split(',').filter(Boolean);
    /* ⭐ RESTRICTIVOS, Y (Guille, 03/10), como en el reel: solo quedan los
       productos que cumplen TODOS los subfiltros encendidos; el que dejaría
       cero se apaga y no se pulsa; el activo lleva su ×; el total va una
       vez sobre la rejilla; las tarjetas suben la flor del filtro encendido. */
    const total = page.querySelector('[data-filter-total]');
    const syncBadges = (keys) => {
      cells.forEach((cell) => {
        const all = [...cell.querySelectorAll('[data-badge-key]')];
        if (!all.length) return;
        const wanted = all.filter((b) => keys.includes(b.dataset.badgeKey));
        const rest = all.filter((b) => !wanted.includes(b) && b.hasAttribute('data-badge-default'));
        const show = [...wanted, ...rest].slice(0, 2);
        all.forEach((b) => {
          const i = show.indexOf(b);
          b.hidden = i === -1;
          b.classList.toggle('card-badge--1', i === 0);
          b.classList.toggle('card-badge--2', i === 1);
        });
      });
    };
    /* ⭐ FILTRO ENLAZABLE (Guille, 06/10): /collections/granolas#sin-gluten
       abre la página con ese subfiltro encendido (varios, separados por
       comas), y la URL sigue a lo que se pulsa, para poder copiarla. El
       nombre es la etiqueta del chip en minúsculas, sin acentos y con
       guiones. Va en el # y no en la consulta: para el buscador sigue siendo
       la misma página, no una copia por cada combinación. */
    const slug = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const wanted = decodeURIComponent(location.hash.slice(1)).split(',').map(slug).filter(Boolean);
    let linked = false;
    const syncUrl = (active) => {
      if (!linked) return;
      const hash = active.map((c) => slug(c.dataset.label)).join(',');
      /* Un # que no es de un filtro (un ancla de la página) no se toca */
      const mine = location.hash.slice(1).split(',').every((part) => !part || rowSlugs().includes(slug(decodeURIComponent(part))));
      if (!mine && !hash) return;
      history.replaceState(history.state, '', location.pathname + location.search + (hash ? '#' + hash : ''));
    };
    const rowSlugs = () => [...filters.querySelectorAll('[data-shop-chip]')].map((c) => slug(c.dataset.label));
    const fromUrl = () => {
      const row = filters.querySelector('[data-shop-chips]:not([hidden])');
      if (row && wanted.length) {
        row.querySelectorAll('[data-shop-chip]').forEach((chip) => {
          if (!wanted.includes(slug(chip.dataset.label))) return;
          const more = chip.closest('.shop-filters__more');
          if (more && more.hidden) row.querySelector('[data-shop-more]')?.click();
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
        });
      }
      linked = true;
      if (row && wanted.length) refreshChips(row);
    };
    const refreshChips = (row) => {
      const rowChips = [...row.querySelectorAll('[data-shop-chip]')];
      const pool = [...new Set(inCurrentTab())];
      const active = rowChips.filter((c) => c.getAttribute('aria-pressed') === 'true');
      const picked = active.map(listOf);
      const match = (lists) => pool.filter((h) => lists.every((list) => list.includes(h)));
      const result = match(picked);
      rowChips.forEach((chip) => {
        const on = chip.getAttribute('aria-pressed') === 'true';
        const would = on ? result.length : match([...picked, listOf(chip)]).length;
        const zero = !on && would === 0;
        chip.querySelector('.chip__remove').hidden = !on;
        chip.setAttribute('aria-disabled', String(zero));
        chip.setAttribute('aria-label', chip.dataset.label + (on ? ' · ' + total.dataset.remove : zero ? ' · ' + total.dataset.none : ''));
      });
      if (total) {
        total.hidden = !active.length;
        total.textContent = (result.length === 1 ? total.dataset.one : total.dataset.other).replace('__N__', result.length);
      }
      chipHandles = active.length ? result : null;
      apply();
      syncBadges(active.map((c) => c.dataset.key).filter(Boolean));
      syncUrl(active);
    };
    page.querySelector('[data-filter-reset]')?.addEventListener('click', () => {
      const row = filters.querySelector('[data-shop-chips]:not([hidden])');
      if (!row) return;
      row.querySelectorAll('[data-shop-chip]').forEach((chip) => {
        chip.classList.remove('is-active');
        chip.setAttribute('aria-pressed', 'false');
      });
      refreshChips(row);
    });
    /* «+ Más filtros»: abre y cierra la segunda fila. Cerrarla con un filtro
       suyo encendido lo apagaría a escondidas: esos filtros se quitan al
       cerrar, y el total se recalcula. */
    filters.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-shop-more]');
      if (!toggle) return;
      const more = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!more) return;
      const open = more.hidden;
      more.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('[data-shop-more-label]').textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      if (!open) {
        more.querySelectorAll('[data-shop-chip][aria-pressed="true"]').forEach((chip) => {
          chip.classList.remove('is-active');
          chip.setAttribute('aria-pressed', 'false');
        });
        refreshChips(toggle.closest('[data-shop-chips]'));
      }
    });
    filters.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-shop-chip]');
      /* El apagado no se enciende: aria-disabled no bloquea el clic por sí solo */
      if (!chip || chip.getAttribute('aria-disabled') === 'true') return;
      const on = chip.getAttribute('aria-pressed') !== 'true';
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', String(on));
      refreshChips(chip.closest('[data-shop-chips]'));
    });

    const first = tabs[0];
    /* Página de una familia: sin pestañas, una sola fila de subfiltros */
    if (!first) {
      const row = filters.querySelector('[data-shop-chips]');
      if (row) refreshChips(row);
      fromUrl();
      cells.forEach((cell) => cell.classList.remove('is-entering'));
    }
    if (first) {
      selectTab(first);
      fromUrl();
      cells.forEach((cell) => cell.classList.remove('is-entering'));
      /* ⚠️ La pastilla se vuelve a colocar CADA VEZ QUE UNA PESTAÑA CAMBIA DE
         ANCHO. `fonts.ready` no basta: puede resolverse antes de que la
         tipografía de marca empiece a cargar, y la pastilla se quedaba con el
         ancho de la letra provisional (más ancha), metida en la pestaña de al
         lado (Guille, 04/10). El observer cubre fuente, zoom y pantalla. */
      const replace = () => placePill(tabs.find((t) => t.getAttribute('aria-selected') === 'true'));
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(replace);
        tabs.forEach((tab) => observer.observe(tab));
      } else {
        document.fonts?.ready.then(replace);
        window.addEventListener('resize', replace);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /* Apertura y cierre suaves del acordeon. El <details> nativo abre de golpe:
     se intercepta el clic del <summary> (tambien llega con Intro y Espacio) y
     se anima el alto del panel; al abrir, los parrafos de la respuesta entran
     uno tras otro subiendo con un fundido, como los textos de los modulos.
     El estado lo sigue llevando el <details> (Cmd+F abre la respuesta que
     contiene lo buscado, y ahi entra sin animacion). Con motion reducido,
     abre y cierra sin animar. */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('.faq__item').forEach(function (item) {
      var summary = item.querySelector('summary');
      var panel = item.querySelector('.faq__panel');
      var answer = item.querySelector('.faq__answer');
      if (!summary || !panel || !answer) return;
      var running = null;
      var sync = function () { item.classList.toggle('is-open', item.open); };
      sync();
      item.addEventListener('toggle', sync);

      var finish = function () {
        if (running) running.cancel();
        running = null;
        panel.style.height = '';
      };

      summary.addEventListener('click', function (event) {
        if (reduce.matches || !panel.animate) return;
        event.preventDefault();
        finish();
        /* Cerrado, Chrome sigue midiendo el contenido: al abrir se parte de 0 */
        var from = item.open ? panel.offsetHeight : 0;
        if (!item.open) {
          item.open = true;
          item.classList.add('is-open');
          var to = panel.scrollHeight;
          running = panel.animate({ height: [from + 'px', to + 'px'] }, { duration: 480, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
          running.onfinish = finish;
          Array.prototype.forEach.call(answer.children, function (child, i) {
            child.animate(
              { opacity: [0, 1], transform: ['translateY(14px)', 'translateY(0)'] },
              { duration: 560, delay: 120 + i * 90, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
            );
          });
        } else {
          item.classList.remove('is-open');
          running = panel.animate({ height: [from + 'px', '0px'] }, { duration: 360, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' });
          answer.animate({ opacity: [1, 0] }, { duration: 200, easing: 'ease-out' });
          running.onfinish = function () { item.open = false; finish(); };
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-shoppable"] && !Shopify.designMode) return;
  try {
    
  /* Un solo punto abierto a la vez: dos tarjetas sobre la misma foto se pisan y
     dejan de leerse como parte de la escena. */
  document.querySelectorAll('[data-shoppable]').forEach((stage) => {
    const dots = [...stage.querySelectorAll('[data-shoppable-dot]')];

    const closeAll = (except) => {
      dots.forEach((dot) => {
        if (dot === except) return;
        dot.setAttribute('aria-expanded', 'false');
        const card = document.getElementById(dot.getAttribute('aria-controls'));
        if (card) card.hidden = true;
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const card = document.getElementById(dot.getAttribute('aria-controls'));
        const abierto = dot.getAttribute('aria-expanded') === 'true';
        closeAll(dot);
        dot.setAttribute('aria-expanded', String(!abierto));
        if (card) card.hidden = abierto;
      });
    });

    /* Esc cierra, y un clic fuera tambien: la tarjeta es un desplegable, no un
       modal, asi que no atrapa el foco ni bloquea el resto de la pagina. */
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(null);
    });

    document.addEventListener('click', (event) => {
      if (!stage.contains(event.target)) closeAll(null);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* «Configurar cookies» del pie. El botón flotante de la app de cookies se
     oculta (las apps lo pintan tarde: se vigila el DOM; !important porque usan
     estilos en línea) y este enlace lo pulsa por debajo. */
  /* ⚠️ BANNER NUEVO DE PANDECTES (13/10). Al actualizar la app, el banner pasó
     a ser un componente propio, <pandectes-cmp>, con todo dentro de su shadow
     DOM: el selector del editor (`.cc-revoke`) ya no encuentra nada, porque un
     selector de la página no entra ahí. Su botón de «cambiar el consentimiento»
     es ahora `.widget`, dentro de ese componente, y nace en la esquina de
     abajo a la derecha, justo debajo de nuestro botón fijo. Se busca también
     ahí dentro: se oculta y se pulsa igual que el antiguo. *Síntoma si falta:*
     «Configurar cookies» lleva a la política de privacidad en vez de reabrir
     el consentimiento, y asoma un segundo botón redondo tras el nuestro. */
  const CMP_HOST = 'pandectes-cmp';
  const CMP_WIDGET = '.widget';
  document.querySelectorAll('[data-cookie-settings]').forEach((link) => {
    const selector = link.dataset.cookieSettings;
    const inside = () => {
      const host = document.querySelector(CMP_HOST);
      return host && host.shadowRoot ? host.shadowRoot : null;
    };
    const find = () => {
      let found = [];
      try { found = selector ? [...document.querySelectorAll(selector)] : []; } catch (e) { found = []; }
      const shadow = inside();
      return shadow ? found.concat([...shadow.querySelectorAll(CMP_WIDGET)]) : found;
    };
    let watched = null;
    const hide = () => {
      find().forEach((el) => el.style.setProperty('display', 'none', 'important'));
      /* Lo de dentro del componente no se ve desde el <body>: se vigila aparte,
         en cuanto el componente existe */
      const shadow = inside();
      if (shadow && shadow !== watched) {
        watched = shadow;
        new MutationObserver(hide).observe(shadow, { childList: true, subtree: true });
      }
    };
    hide();
    new MutationObserver(hide).observe(document.body, { childList: true, subtree: true });

    link.addEventListener('click', (event) => {
      const appButton = find()[0];
      if (appButton) {
        event.preventDefault();
        (appButton.querySelector('a, button') || appButton).click();
        return;
      }
      if (typeof window.privacyBanner?.showPreferences === 'function') {
        event.preventDefault();
        try { window.privacyBanner.showPreferences(); } catch (e) { /* sigue al href */ }
        setTimeout(() => {
          const shown = [...document.querySelectorAll('[id^="shopify-pc__"]')].some((el) => el.offsetHeight > 0);
          if (!shown) window.location.href = link.href;
        }, 600);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header').forEach((header) => {
    const root = header.parentElement;
    /* Todas las secciones sticky del grupo (faldon de envio + navbar): el
       auto-ocultado las mueve juntas, asi que hay que fijarlas juntas */
    const wraps = [...document.querySelectorAll('.shopify-section-group-header-group')];
    const drawer = root.querySelector('[data-nav-drawer]');
    const search = root.querySelector('[data-search-dialog]');

    /* Mientras hay un overlay abierto la navbar no se esconde: ver .is-pinned */
    const pin = (on) => wraps.forEach((wrap) => wrap.classList.toggle('is-pinned', on));

    const bind = (dialog, opener, closer) => {
      if (!dialog) return;
      /* Puede haber más de un botón que abra el mismo panel (el buscador va
         a la izquierda en móvil y a la derecha en escritorio) */
      header.querySelectorAll(opener).forEach((openBtn) => {
        openBtn.addEventListener('click', () => {
          wraps.forEach((wrap) => wrap.classList.remove('is-hidden'));
          pin(true);
          dialog.showModal();
        });
      });
      dialog.querySelectorAll(closer).forEach((btn) => {
        btn.addEventListener('click', () => dialog.close());
      });
      /* Clic fuera del panel: el hueco que queda a los lados es el propio
         dialog, asi que basta con mirar si el click aterrizo en el */
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => pin(false));
    };

    bind(drawer, '[data-nav-open]', '[data-nav-close]');
    bind(search, '[data-search-open]', '[data-search-close]');

    /* Megamenu: se abre al pasar el raton y tambien con clic y teclado (el
       hover solo no vale: ni tactil ni teclado). Al salir espera un momento,
       porque entre la entrada y el panel hay un hueco que el puntero cruza. */
    const megas = [...header.querySelectorAll('[data-mega]')];
    let megaTimer;
    const megaParts = (mega) => [mega.querySelector('[data-mega-toggle]'), mega.querySelector('[data-mega-panel]')];
    const megaSet = (mega, on) => {
      const [toggle, panel] = megaParts(mega);
      toggle.setAttribute('aria-expanded', String(on));
      panel.hidden = !on;
    };
    const megaSync = () => pin(megas.some((mega) => !megaParts(mega)[1].hidden));
    megas.forEach((mega) => {
      const [toggle, panel] = megaParts(mega);
      const open = () => {
        clearTimeout(megaTimer);
        megas.forEach((other) => megaSet(other, other === mega));
        megaSync();
      };
      const close = () => {
        megaSet(mega, false);
        megaSync();
      };
      toggle.addEventListener('click', () => (panel.hidden ? open() : close()));
      mega.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open();
      });
      mega.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') megaTimer = setTimeout(close, 200);
      });
      mega.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || panel.hidden) return;
        close();
        toggle.focus();
      });
      mega.addEventListener('focusout', (event) => {
        if (!mega.contains(event.relatedTarget)) close();
      });

      /* Las miniaturas siguen a la categoria sobre la que esta el puntero */
      const tabs = [...mega.querySelectorAll('[data-mega-tab]')];
      const panes = [...mega.querySelectorAll('[data-mega-pane]')];
      const show = (tab) => {
        panes.forEach((pane) => { pane.hidden = pane.dataset.megaPane !== tab.dataset.megaTab; });
        tabs.forEach((other) => other.classList.toggle('is-active', other === tab));
      };
      tabs.forEach((tab) => {
        tab.addEventListener('pointerenter', () => show(tab));
        tab.addEventListener('focus', () => show(tab));
      });
    });

    /* Desplegable de perfil: clic y teclado (sin hover: es una accion, no una
       entrada de navegacion). Se cierra con Escape, al salir el foco o al
       pulsar fuera, y al abrirse cierra el megamenu que hubiera. */
    header.querySelectorAll('[data-account-menu]').forEach((menu) => {
      const toggle = menu.querySelector('[data-account-toggle]');
      const panel = menu.querySelector('[data-account-panel]');
      const set = (on) => {
        toggle.setAttribute('aria-expanded', String(on));
        panel.hidden = !on;
        if (on) megas.forEach((mega) => megaSet(mega, false));
        pin(on);
      };
      toggle.addEventListener('click', () => set(panel.hidden));
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || panel.hidden) return;
        set(false);
        toggle.focus();
      });
      menu.addEventListener('focusout', (event) => {
        if (!panel.hidden && event.relatedTarget && !menu.contains(event.relatedTarget)) set(false);
      });
      document.addEventListener('click', (event) => {
        if (!panel.hidden && !menu.contains(event.target)) set(false);
      });
    });

    /* «Configurar cookies» del menu: cierra el cajon y pulsa el enlace del pie,
       que es quien conoce el boton de la app. Sin el, sigue a la politica. */
    root.querySelectorAll('[data-nav-cookies]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const footerLink = document.querySelector('.site-footer [data-cookie-settings]');
        if (!footerLink) return;
        event.preventDefault();
        drawer.close();
        footerLink.click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  /* El listado: dialog nativo (foco atrapado y Esc de serie). Clic fuera del
     panel lo cierra; al cerrar, el foco vuelve al botón que lo abrió. */
  document.querySelectorAll('.logo-marquee').forEach(function (section) {
    var dialog = section.querySelector('[data-logo-list]');
    var open = section.querySelector('[data-logo-list-open]');
    var close = section.querySelector('[data-logo-list-close]');
    if (!dialog || !open) return;
    open.addEventListener('click', function () { dialog.showModal(); });
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () { open.focus({ preventScroll: true }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-facts"] && !Shopify.designMode) return;
  try {
    
  /* Pestañas del pack: clic y flechas (tambien Inicio/Fin); el foco sigue a
     la seleccion. Si el script no llega, los paneles se quedan apilados. */
  document.querySelectorAll('[data-facts-tabs]').forEach(function (root) {
    var list = root.querySelector('[role="tablist"]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-facts-panel]'));
    if (!list || tabs.length < 2 || tabs.length !== panels.length) return;
    var select = function (index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.classList.toggle('is-active', on);
        tab.tabIndex = on ? 0 : -1;
        panels[i].hidden = !on;
      });
    };
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (event) {
        var next = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        tabs[next].focus();
        select(next);
      });
    });
    list.hidden = false;
    panels.forEach(function (panel) {
      var title = panel.querySelector('.product-facts__panel-title');
      if (title) title.classList.add('visually-hidden');
    });
    select(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  /* El color del modulo sale de la PRIMERA foto de la galeria del producto: el
     morado de la Keto, el amarillo de la Bowl Lovers. Liquid no puede leer un
     color de un JPG, asi que se muestrea aqui.

     ⭐ Se muestrean los BORDES y no la imagen entera: en un bodegon el color
     dominante puede ser el producto, y lo que buscamos es el fondo. El marco
     exterior es fondo casi con seguridad, y ademas se descartan los pixeles
     casi blancos para no traerse un reflejo.

     ⚠️ Si el producto trae `custom.feature_color`, este script ni corre: un
     color decidido siempre gana a uno deducido. */
  document.querySelectorAll('[data-sample-from]').forEach((capa) => {
    const src = capa.dataset.sampleFrom;
    if (!src) return;

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.referrerPolicy = 'no-referrer';

    img.onload = () => {
      try {
        const L = 48;
        const c = document.createElement('canvas');
        c.width = L;
        c.height = L;
        const ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, L, L);
        const { data } = ctx.getImageData(0, 0, L, L);

        let r = 0, g = 0, b = 0, n = 0;
        const mira = (x, y) => {
          const i = (y * L + x) * 4;
          const [pr, pg, pb, pa] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
          if (pa < 200) return;
          /* Fuera los casi blancos y los casi negros: son reflejos y sombras,
             no el fondo que da el tono. */
          const max = Math.max(pr, pg, pb), min = Math.min(pr, pg, pb);
          if (max > 244 || max < 24) return;
          r += pr; g += pg; b += pb; n += 1;
        };

        for (let i = 0; i < L; i += 2) {
          mira(i, 0); mira(i, L - 1); mira(0, i); mira(L - 1, i);
        }
        if (!n) return;

        capa.style.backgroundColor = `rgb(${Math.round(r / n)} ${Math.round(g / n)} ${Math.round(b / n)})`;
      } catch (e) {
        /* Si el CDN no deja leer el canvas, se queda el color de la seccion:
           el modulo no depende de esto para verse bien. */
      }
    };

    img.src = src;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reel"] && !Shopify.designMode) return;
  try {
    
  /* El arco: cada tarjeta se coloca según su distancia k a la activa (en
     bucle): desplazada, más baja, girada y más pequeña cuanto más lejos. Las
     que quedan a 3 o más se ocultan, y por eso el salto de un extremo al otro
     del bucle no se ve (solo va en bucle con 7 o más; con menos, en fila).
     No se duplica ninguna tarjeta para rellenar. */
  /* Se monta al cargar y SE VUELVE A MONTAR cuando la sección se recarga (el
     editor de Shopify al cambiar un ajuste, o la recarga en caliente de theme
     dev): esas recargas cambian el HTML pero no vuelven a ejecutar este JS, y
     sin él queda la fila plana de respaldo en vez del arco. */
  var initReel = function (section) {
    if (!section || section.dataset.reelReady) return;
    section.dataset.reelReady = 'true';
    var stages = Array.prototype.slice.call(section.querySelectorAll('[data-reel-stage]'));
    if (!stages.length) return;
    section.classList.add('is-arc');
    var num = function (name, fallback) {
      var v = parseFloat(getComputedStyle(section).getPropertyValue(name));
      return isNaN(v) ? fallback : v;
    };

    var reels = stages.map(function (stage) {
      var track = stage.querySelector('[data-reel-track]');
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return null;
      /* ⭐ Las tarjetas de «Primeros productos» van delante, en ese orden, y
         la primera es con la que arranca el arco (Guille, 02/10: siempre La
         Original y luego Real Fooding). Se mueven tambien en el DOM, para
         que el orden del teclado y del lector sea el mismo que el visual. */
      var pins = (stage.dataset.pinFirst || '').split(',').filter(Boolean);
      if (pins.length) {
        var pinned = [];
        pins.forEach(function (handle) {
          var card = originals.find(function (c) { return c.dataset.handle === handle; });
          if (card) pinned.push(card);
        });
        originals = pinned.concat(originals.filter(function (c) { return pinned.indexOf(c) === -1; }));
        originals.forEach(function (card) { track.appendChild(card); });
      }
      var reel = { stage: stage, cards: [], active: 0, dragged: false };

      /* ⭐ OLA EN EL NOMBRE (Guille, 03/10): cuando una tarjeta LLEGA al
         centro, las letras de su nombre se levantan una tras otra y caen con
         un rebote, el mismo gesto que el logo del pie al montarse
         (logo-assemble: back.out en cascada). Solo al cambiar de tarjeta, no
         al cargar; con motion reducido, quieto. El corte en letras se hace
         una vez por tarjeta y se queda (SplitText respeta el <br> del nombre). */
      var calmMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var wave = function (card) {
        if (!window.gsap || !window.SplitText || calmMotion.matches) return;
        var el = card.querySelector('.product-reel__title > span:not(.product-reel__kicker)') || card.querySelector('.product-reel__title');
        if (!el) return;
        if (!el.lnySplit) el.lnySplit = SplitText.create(el, { type: 'words,chars' });
        var chars = el.lnySplit.chars;
        gsap.killTweensOf(chars);
        gsap.timeline({ delay: 0.25 })
          .to(chars, {
            y: '-0.32em',
            rotation: function (i) { return (i % 2 ? 1 : -1) * 6; },
            duration: 0.22,
            ease: 'power2.out',
            stagger: 0.03,
          })
          .to(chars, { y: 0, rotation: 0, duration: 0.6, ease: 'back.out(3)', stagger: 0.03 }, 0.2);
      };

      reel.layout = function () {
        var cards = reel.cards;
        if (!cards.length) return;
        reel.moving = true;
        clearTimeout(reel.movingTimer);
        reel.movingTimer = setTimeout(function () { reel.moving = false; }, 800);
        var w = cards[0].offsetWidth || 300;
        var spacing = w * num('--reel-spacing', 1.14);
        var drop1 = num('--reel-drop-1', 34);
        var drop2 = num('--reel-drop-2', 113);
        var tilt = num('--reel-tilt', 2);
        var shrink = num('--reel-shrink', 0.095);
        var n = cards.length;
        cards.forEach(function (card, i) {
          var k = i - reel.active;
          if (reel.loop) {
            k = ((k % n) + n) % n;
            if (k > n / 2) k -= n;
          }
          var a = Math.abs(k);
          var s = k < 0 ? -1 : 1;
          var x = s * (spacing * a - spacing * 0.05 * a * (a - 1));
          var y = a === 0 ? 0 : a === 1 ? drop1 : drop2 + (a - 2) * (drop2 - drop1);
          var scale = Math.max(0.6, 1 - shrink * a);
          card.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px) rotate(' + (tilt * k) + 'deg) scale(' + scale.toFixed(3) + ')';
          card.style.opacity = a > 2 ? '0' : '1';
          card.style.zIndex = String(10 - a);
          card.style.pointerEvents = a > 2 ? 'none' : '';
          card.classList.toggle('is-active', a === 0);
          /* Las que van a entrar (hasta 3 de distancia) se piden ya: fuera de
             la pantalla el lazy del navegador no las cargaba, y al llegar con
             el pase automático entraban en blanco */
          if (a <= 3) {
            var img = card.querySelector('.product-reel__media img');
            if (img && img.loading === 'lazy') img.loading = 'eager';
          }
          if (!card.hasAttribute('aria-hidden')) card.setAttribute('aria-current', a === 0 ? 'true' : 'false');
        });
        /* La que acaba de llegar al centro hace la ola (no en el primer montaje) */
        var center = cards[reel.active];
        if (center && center !== reel.waved) {
          if (reel.waved !== undefined) wave(center);
          reel.waved = center;
        }
      };
      reel.go = function (step) {
        if (reel.cards.length < 2) return;
        var next = reel.active + step;
        if (reel.loop) next = (next + reel.cards.length) % reel.cards.length;
        else next = Math.max(0, Math.min(reel.cards.length - 1, next));
        reel.active = next;
        reel.layout();
        reel.arrows();
      };

      /* En fila, la flecha del extremo al que ya se ha llegado se apaga (disabled) */
      var prev = stage.querySelector('[data-reel-prev]');
      var nextBtn = stage.querySelector('[data-reel-next]');
      reel.arrows = function () {
        prev.disabled = !reel.loop && reel.active === 0;
        nextBtn.disabled = !reel.loop && reel.active === reel.cards.length - 1;
      };

      /* Monta el arco con las tarjetas visibles: todas, o las del chip
         activo. NUNCA se duplican para rellenar (Guille, 30/09): con 7 o más
         va en bucle, porque el salto de un extremo al otro queda oculto; con
         menos, en fila, empezando por la del medio y sin dar la vuelta. */
      reel.build = function (handles) {
        var shown = originals.filter(function (card) {
          var on = !handles || handles.indexOf(card.dataset.handle) !== -1;
          card.hidden = !on;
          if (!on) { card.classList.remove('is-active'); card.removeAttribute('aria-current'); }
          return on;
        });
        /* Ninguno cumple los filtros: estado vacío con salida, no un hueco */
        var empty = stage.querySelector('[data-filter-empty]');
        var arc = stage.querySelector('.product-reel__arc');
        if (empty) empty.hidden = shown.length > 0;
        if (arc) arc.hidden = shown.length === 0;
        if (!shown.length) {
          reel.cards = [];
          return;
        }
        reel.cards = shown;
        reel.loop = shown.length >= 7;
        reel.active = reel.loop ? 0 : Math.floor((shown.length - 1) / 2);
        stage.classList.toggle('is-single', shown.length === 1);
        reel.layout();
        reel.arrows();
      };

      stage.querySelector('[data-reel-prev]').addEventListener('click', function () { reel.go(-1); });
      stage.querySelector('[data-reel-next]').addEventListener('click', function () { reel.go(1); });
      stage.addEventListener('keydown', function (event) {
        if (event.target.closest('[data-reel-chip]')) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); reel.go(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); reel.go(1); }
      });

      /* Arrastre: pasado un umbral, avanza o retrocede; y el clic que cierra
         el gesto no navega */
      var startX = null;
      /* Sin el arrastre nativo de imágenes y enlaces, que cancelaba el gesto */
      stage.addEventListener('dragstart', function (event) { event.preventDefault(); });
      stage.addEventListener('pointerdown', function (event) {
        if (event.target.closest('button')) return;
        startX = event.clientX;
        reel.dragged = false;
      });
      var end = function (event) {
        if (startX === null) return;
        var dx = event.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) { reel.dragged = true; reel.go(dx < 0 ? 1 : -1); }
      };
      stage.addEventListener('pointerup', end);
      /* Si el gesto termina fuera de la tarjeta, cuenta igual */
      window.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', function () { startX = null; });

      /* Una tarjeta lateral viene al centro; la central lleva al producto */
      track.addEventListener('click', function (event) {
        var card = event.target.closest('[data-reel-card]');
        if (!card) return;
        if (reel.dragged) { event.preventDefault(); reel.dragged = false; return; }
        var i = reel.cards.indexOf(card);
        if (i !== -1 && i !== reel.active) { event.preventDefault(); reel.active = i; reel.layout(); reel.arrows(); }
      });
      /* Con el teclado, la tarjeta que recibe el foco se pone en el centro */
      track.addEventListener('focusin', function (event) {
        var i = reel.cards.indexOf(event.target.closest('[data-reel-card]'));
        if (i !== -1 && i !== reel.active) { reel.active = i; reel.layout(); reel.arrows(); }
      });

      /* ⭐ FILTROS RESTRICTIVOS, Y (Guille, 03/10): con varios chips solo
         quedan los productos que cumplen TODOS. El chip que, sumado a los
         encendidos, dejaría cero se apaga y no se puede pulsar; el activo
         lleva su × para quitarlo; el total de resultados se dice una sola vez.
         Las tarjetas suben la flor de cada filtro encendido (syncBadges). */
      var chips = Array.prototype.slice.call(stage.querySelectorAll('[data-reel-chip]'));
      var here = originals.map(function (card) { return card.dataset.handle; });
      var total = stage.querySelector('[data-filter-total]');
      var isOn = function (chip) { return chip.getAttribute('aria-pressed') === 'true'; };
      var listOf = function (chip) {
        return chip.dataset.handles.split(',').filter(function (h) { return here.indexOf(h) !== -1; });
      };
      var matching = function (lists) {
        return here.filter(function (h, i) {
          return here.indexOf(h) === i && lists.every(function (list) { return list.indexOf(h) !== -1; });
        });
      };
      var syncBadges = function (keys) {
        originals.forEach(function (card) {
          var all = Array.prototype.slice.call(card.querySelectorAll('[data-badge-key]'));
          if (!all.length) return;
          /* Sin filtros: las de siempre. Con filtros: primero las de los
             filtros encendidos que tenga, y detrás las de siempre */
          var wanted = all.filter(function (b) { return keys.indexOf(b.dataset.badgeKey) !== -1; });
          var rest = all.filter(function (b) { return wanted.indexOf(b) === -1 && b.hasAttribute('data-badge-default'); });
          var show = wanted.concat(rest).slice(0, 2);
          all.forEach(function (b) {
            var i = show.indexOf(b);
            b.hidden = i === -1;
            b.classList.toggle('card-badge--1', i === 0);
            b.classList.toggle('card-badge--2', i === 1);
          });
        });
      };
      var refreshChips = function () {
        var active = chips.filter(isOn);
        var picked = active.map(listOf);
        var result = matching(picked);
        chips.forEach(function (chip) {
          var on = isOn(chip);
          var would = on ? result.length : matching(picked.concat([listOf(chip)])).length;
          var zero = !on && would === 0;
          chip.querySelector('.chip__remove').hidden = !on;
          chip.setAttribute('aria-disabled', String(zero));
          chip.setAttribute('aria-label', chip.dataset.label + (on ? ' · ' + total.dataset.remove : zero ? ' · ' + total.dataset.none : ''));
        });
        if (total) {
          total.hidden = !active.length;
          total.textContent = (result.length === 1 ? total.dataset.one : total.dataset.other).replace('__N__', result.length);
        }
        reel.build(active.length ? result : null);
        syncBadges(active.map(function (c) { return c.dataset.key; }).filter(Boolean));
      };
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          /* El apagado no se enciende: aria-disabled no bloquea el clic por sí solo */
          if (chip.getAttribute('aria-disabled') === 'true') return;
          var on = !isOn(chip);
          chip.setAttribute('aria-pressed', String(on));
          chip.classList.toggle('is-active', on);
          refreshChips();
        });
      });
      refreshChips();
      var reset = stage.querySelector('[data-filter-reset]');
      if (reset) reset.addEventListener('click', function () {
        chips.forEach(function (chip) { chip.setAttribute('aria-pressed', 'false'); chip.classList.remove('is-active'); });
        refreshChips();
      });

      return reel;
    });

    /* Pestañas: cambian de panel y mueven la pastilla */
    /* Autoplay: pasa a la siguiente tarjeta cada N segundos mientras el
       módulo está en pantalla y nadie lo está usando. Se para con el ratón
       sobre el carrusel, con el foco de teclado en él y con la pestaña del navegador en
       segundo plano; cualquier gesto propio (flecha, arrastre, chip) reinicia
       la cuenta para no pisar al usuario. Con movimiento reducido, apagado. */
    var current = 0;
    var auto = (function () {
      var seconds = parseFloat(section.dataset.autoplay) || 0;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      var inView = false;
      var hovering = false;
      var focused = false;
      var api = { restart: function () {} };
      if (!seconds || reduced) return api;

      var running = function () { return inView && !hovering && !focused && !document.hidden; };
      var tick = function () {
        timer = null;
        /* Con un diálogo abierto (la compra rápida) el carrusel espera: si
           siguiera pasando por detrás, al cerrar ya no estaría la tarjeta
           desde la que se abrió */
        if (document.querySelector('dialog[open]')) {
          timer = setTimeout(tick, seconds * 1000);
          return;
        }
        var reel = reels[current];
        if (reel && reel.cards.length > 1) {
          /* En fila, al llegar al final vuelve al principio */
          if (!reel.loop && reel.active === reel.cards.length - 1) {
            reel.active = 0;
            reel.layout();
            reel.arrows();
          } else {
            reel.go(1);
          }
        }
        api.restart();
      };
      api.restart = function () {
        clearTimeout(timer);
        timer = running() ? setTimeout(tick, seconds * 1000) : null;
      };

      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        api.restart();
      }, { threshold: 0.35 }).observe(section);
      /* La zona que pausa es el CARRUSEL (la pista con sus flechas), no el
         módulo entero: con el titular y los filtros dentro, el ratón estaba
         casi siempre «encima» y el pase no se llegaba a ver (Guille, 30/09).
         Solo el ratón pausa por estar encima: en táctil no hay «encima». */
      var arcs = Array.prototype.slice.call(section.querySelectorAll('.product-reel__arc'));
      arcs.forEach(function (arc) {
        arc.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse') return;
          hovering = true;
          api.restart();
        });
        arc.addEventListener('pointerleave', function (event) {
          if (event.pointerType !== 'mouse') return;
          hovering = false;
          api.restart();
        });
      });
      /* El foco pausa solo si es de TECLADO y está en el carrusel: un clic en
         una flecha o una pestaña deja el foco puesto, y eso no es «usarlo» */
      section.addEventListener('focusin', function (event) {
        focused = arcs.some(function (arc) { return arc.contains(event.target); }) && event.target.matches(':focus-visible');
        api.restart();
      });
      section.addEventListener('focusout', function (event) {
        if (event.relatedTarget && arcs.some(function (arc) { return arc.contains(event.relatedTarget); })) return;
        focused = false;
        api.restart();
      });
      section.addEventListener('pointerup', api.restart);
      document.addEventListener('visibilitychange', api.restart);
      return api;
    })();

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    var pill = section.querySelector('.pill-tabs__pill');
    var placePill = function (tab) {
      if (!pill || !tab) return;
      pill.style.setProperty('--pill-w', tab.offsetWidth + 'px');
      pill.style.setProperty('--pill-x', tab.offsetLeft + 'px');
    };
    var select = function (index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        stages[i].hidden = !on;
      });
      placePill(tabs[index]);
      current = index;
      auto.restart();
      var reel = reels[index];
      if (reel) {
        /* Las tarjetas entran desde abajo */
        reel.cards.forEach(function (card) { card.style.transition = 'none'; card.style.opacity = '0'; card.style.transform += ' translateY(60px)'; });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            reel.cards.forEach(function (card) { card.style.transition = ''; });
            reel.layout();
          });
        });
      }
    };
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var next = (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        select(next);
      });
    });
    placePill(tabs[0]);
    if (document.fonts) document.fonts.ready.then(function () { placePill(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]); });
    /* fonts.ready puede llegar antes que la tipografía de marca: la pastilla
       se recoloca cada vez que una pestaña cambia de ancho (como la Tienda) */
    if ('ResizeObserver' in window) {
      var pillObserver = new ResizeObserver(function () {
        placePill(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]);
      });
      tabs.forEach(function (t) { pillObserver.observe(t); });
    }

    window.addEventListener('resize', function () {
      reels.forEach(function (reel) { if (reel) reel.layout(); });
      placePill(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]);
    });
  };

  var initAll = function (root) {
    (root || document).querySelectorAll('[data-product-reel]').forEach(initReel);
  };
  initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  /* Red de seguridad para la recarga en caliente, que no avisa: si aparece un
     reel sin montar, se monta */
  new MutationObserver(function () { initAll(); }).observe(document.body, { childList: true, subtree: true });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Ficha de producto: el JS solo sincroniza lo que ya funciona sin el.
  // Nada de aritmetica de dinero aqui: los importes vienen pintados por
  // Liquid con el filtro money y este script solo destapa el que toca.
  document.querySelectorAll('[data-pdp]').forEach((root) => {
    const form = root.querySelector('.pdp__form');
    if (!form) return;

    const stage = root.querySelector('[data-pdp-stage]');
    const thumbs = Array.from(root.querySelectorAll('[data-product-thumb]'));
    const slides = Array.from(root.querySelectorAll('[data-pdp-slide]'));
    const prices = Array.from(root.querySelectorAll('[data-pdp-price]'));
    const totals = Array.from(root.querySelectorAll('[data-pdp-total]'));
    const planFields = root.querySelector('[data-pdp-plan-fields]');
    const planSelect = root.querySelector('[data-pdp-plan-select]');
    const addButton = root.querySelector('[data-pdp-add]');

    const currentValue = (name) => {
      const checked = form.querySelector('input[name="' + name + '"]:checked');
      if (checked) return checked.value;
      const single = form.querySelector('[name="' + name + '"]');
      return single ? single.value : '';
    };

    // El barrido de la galeria. Los valores salen de los tokens de motion: la
    // curva de aqui es la traduccion a GSAP de --motion-ease-in-out.
    const rootStyles = getComputedStyle(document.documentElement);
    const cssTime = (name, fallback) => {
      const value = parseFloat(rootStyles.getPropertyValue(name));
      return Number.isFinite(value) ? value / 1000 : fallback;
    };
    const SWEEP_DURATION = cssTime('--motion-duration-600', 0.6);
    const SWEEP_EASE = rootStyles.getPropertyValue('--motion-ease-gallery').trim() || 'power2.inOut';
    const quietMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scrollToMedia = (mediaId) => {
      if (!stage || !mediaId) return;
      const slide = slides.find((el) => el.dataset.mediaId === mediaId);
      if (!slide) return;
      // Medido en pantalla y no con offsetLeft: asi da igual quien sea el
      // offsetParent de la diapositiva.
      const left = slide.getBoundingClientRect().left - stage.getBoundingClientRect().left;
      const destino = stage.scrollLeft + left;

      // Sin GSAP o con motion reducido, el salto lo hace el navegador. El
      // theme sigue funcionando entero: cambia el gesto, no lo que se ve.
      if (!window.gsap || quietMotion) {
        stage.scrollTo({ left: destino, behavior: quietMotion ? 'auto' : 'smooth' });
        return;
      }

      // ⚠️⚠️ EL SNAP SE APAGA MIENTRAS DURA EL BARRIDO. Con `scroll-snap-type:
      // x mandatory` puesto, el navegador corrige el scrollLeft en cada
      // fotograma para clavarlo en la parada mas cercana, asi que pelea contra
      // la animacion y el recorrido sale a tirones o se planta a medias. Es la
      // misma trampa que ya dio el arrastre del carrusel de la home el 13/08.
      // Vuelve al terminar, que es cuando el usuario recupera el control.
      //
      // ⚠️ Y CON EL, EL `scroll-behavior: smooth` DEL CSS: cada fotograma de la
      // animacion escribe `scrollLeft`, y un scroll programado con smooth
      // puesto lo convierte en OTRO desplazamiento suave — sesenta por segundo,
      // cada uno persiguiendo al anterior. La curva que se veria no seria la
      // nuestra. Se queda para el salto por ancla, que es quien lo necesita.
      stage.style.scrollSnapType = 'none';
      stage.style.scrollBehavior = 'auto';
      window.gsap.to(stage, {
        scrollLeft: destino,
        duration: SWEEP_DURATION,
        ease: SWEEP_EASE,
        overwrite: true,
        onComplete: () => {
          stage.style.scrollSnapType = '';
          stage.style.scrollBehavior = '';
        },
      });
    };

    const sync = () => {
      const variantId = currentValue('id');
      const quantity = currentValue('quantity');

      prices.forEach((el) => {
        el.hidden = el.dataset.variant !== variantId;
      });
      totals.forEach((el) => {
        el.hidden = !(el.dataset.variant === variantId && el.dataset.qty === quantity);
      });

      const purchase = form.querySelector('input[name="purchase_type"]:checked');
      const subscribing = Boolean(purchase) && purchase.value === 'subscription';
      if (planFields) planFields.hidden = !subscribing;
      // Un select desactivado no viaja en el formulario: asi la compra unica
      // nunca arrastra un selling_plan por error.
      if (planSelect && planSelect.name) planSelect.disabled = !subscribing;

      if (addButton) {
        const checkedVariant = form.querySelector('input[name="id"]:checked');
        const available = checkedVariant ? checkedVariant.disabled === false : true;
        addButton.disabled = !available;
        const label = available ? addButton.dataset.labelAdd : addButton.dataset.labelSoldOut;
        if (label) addButton.textContent = label;
      }
    };

    // Barra de compra fija (movil). Se saca al <body>: dentro de la seccion,
    // cualquier transform del motion la dejaria fija respecto al modulo y no
    // a la pantalla. Su boton sigue siendo un submit del formulario (atributo
    // `form`), este donde este. Aqui solo se decide cuando se ve —cuando el
    // boton principal no esta en pantalla y ya se ha movido la pagina— y se
    // le copia el texto y el estado del principal.
    const sticky = root.querySelector('[data-pdp-sticky]');
    if (sticky && addButton) {
      document.querySelectorAll('body > [data-pdp-sticky]').forEach((old) => old.remove());
      document.body.appendChild(sticky);
      sticky.hidden = false;
      const stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
      let mainInView = true;
      let moved = false;
      const place = () => sticky.classList.toggle('is-visible', moved && !mainInView && !addButton.disabled);
      const mirror = () => {
        stickyAdd.disabled = addButton.disabled;
        if (stickyAdd.getAttribute('aria-busy') !== 'true') stickyAdd.textContent = addButton.dataset.labelAdd;
        place();
      };
      new IntersectionObserver(([entry]) => { mainInView = entry.isIntersecting; place(); }).observe(addButton);
      window.addEventListener('scroll', () => { moved = true; place(); }, { once: true, passive: true });
      new MutationObserver(mirror).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    // «Avisame cuando vuelva». Los disparadores son enlaces mailto: solo se
    // interceptan si hay dialogo Y clave de Klaviyo; si no, el mailto sigue.
    const notify = root.querySelector('[data-notify]');
    if (notify && typeof notify.showModal === 'function') {
      const klaviyoKey = () => {
        if (notify.dataset.klaviyoKey) return notify.dataset.klaviyoKey;
        const script = document.querySelector('script[src*="klaviyo"][src*="company_id="]');
        const match = script && script.src.match(/company_id=([A-Za-z0-9]+)/);
        return match ? match[1] : '';
      };
      const notifyForm = notify.querySelector('[data-notify-form]');
      const status = notify.querySelector('[data-notify-status]');
      const say = (state) => {
        status.textContent = state ? status.dataset[state] : '';
        status.dataset.state = state || '';
        status.hidden = !state;
      };
      let opener = null;

      root.querySelectorAll('[data-notify-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          if (!klaviyoKey()) return;
          event.preventDefault();
          opener = trigger;
          const wanted = trigger.dataset.notifyVariant;
          const option = wanted && notifyForm.querySelector('input[type="radio"][value="' + wanted + '"]');
          if (option) option.checked = true;
          say('');
          notify.showModal();
        });
      });

      notify.querySelector('[data-notify-close]').addEventListener('click', () => notify.close());
      // Clic en el velo: el propio <dialog> es el objetivo solo fuera de la caja
      notify.addEventListener('click', (event) => {
        if (event.target === notify) notify.close();
      });
      notify.addEventListener('close', () => {
        if (opener) opener.focus();
      });

      notifyForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(notifyForm);
        const submit = notifyForm.querySelector('[type="submit"]');
        submit.disabled = true;
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(klaviyoKey()), {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: { data: { type: 'profile', attributes: { email: data.get('email') } } },
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + data.get('notify_variant') } },
              },
            },
          }),
        })
          .then((response) => {
            if (!response.ok) throw new Error(String(response.status));
            say('success');
            notifyForm.reset();
          })
          .catch(() => say('error'))
          .finally(() => { submit.disabled = false; });
      });
    }

    form.addEventListener('change', (event) => {
      sync();
      const target = event.target;
      if (target && target.name === 'id' && target.dataset.mediaId) {
        scrollToMedia(target.dataset.mediaId);
      }
    });

    // Las miniaturas son enlaces: sin JS el navegador ya salta a su diapositiva.
    // Con JS se mueve el carril sin ensuciar la URL con un hash.
    //
    // ⭐ Y BASTA CON PASAR EL RATON (Guille, 14/08): pedir un clic para ver otra
    //   foto es un peaje en la pieza que mas se mira de la ficha.
    //   ⚠️ El hover NO sustituye al clic, se suma: en tactil no existe, asi que
    //   el clic sigue siendo el gesto que tiene que funcionar solo.
    //   ⚠️ Y se ignora mientras el dedo/raton arrastra el carril, o mover la
    //   galeria por encima de las miniaturas dispararia saltos en cadena.
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToMedia(thumb.dataset.mediaId);
      });

      thumb.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        scrollToMedia(thumb.dataset.mediaId);
      });
    });

    if (stage && thumbs.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const mediaId = entry.target.dataset.mediaId;
            thumbs.forEach((thumb) => {
              if (thumb.dataset.mediaId === mediaId) {
                thumb.setAttribute('aria-current', 'true');
              } else {
                thumb.removeAttribute('aria-current');
              }
            });
          });
        },
        { root: stage, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
    }

    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-article"]) return;
  try {
    
  // Una imagen del cuerpo que ya no existe (los articulos antiguos apuntan a
  // archivos borrados) se retira: un marco vacio estropea el articulo.
  document.querySelectorAll('.recipe-page__body img').forEach((image) => {
    const drop = () => image.remove();
    if (image.complete && image.naturalWidth === 0) drop();
    else image.addEventListener('error', drop, { once: true });
  });

  document.querySelectorAll('.recipe-page').forEach((page) => {
    page.querySelector('[data-recipe-print-button]')?.addEventListener('click', () => window.print());

    const status = page.querySelector('[data-share-status]');
    page.querySelector('[data-share-copy]')?.addEventListener('click', async (event) => {
      const url = event.currentTarget.dataset.shareCopy;
      try {
        await navigator.clipboard.writeText(url);
        if (status) status.textContent = page.dataset.copied || '';
      } catch (e) {
        /* Sin portapapeles (http, permisos): se enseña el enlace para copiarlo a mano */
        if (status) status.textContent = url;
      }
    });

    /* La ola del nombre al pasar el ratón por la tarjeta de la granola: el
       gesto del reel (back.out en cascada), aquí con el hover porque la
       tarjeta no viaja a ningún centro. Con motion reducido, quieta. */
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    page.querySelectorAll('[data-buy-card]').forEach((card) => {
      const name = card.querySelector('[data-buy-name]');
      if (!name) return;
      card.querySelector('.buy-card__link').addEventListener('mouseenter', () => {
        if (!window.gsap || !window.SplitText || calm.matches) return;
        if (!name.lnySplit) name.lnySplit = SplitText.create(name, { type: 'words,chars' });
        const chars = name.lnySplit.chars;
        gsap.killTweensOf(chars);
        gsap.timeline()
          .to(chars, { y: '-0.32em', rotation: (i) => (i % 2 ? 1 : -1) * 6, duration: 0.22, ease: 'power2.out', stagger: 0.03 })
          .to(chars, { y: 0, rotation: 0, duration: 0.6, ease: 'back.out(3)', stagger: 0.03 }, 0.2);
      });
    });

    /* En móvil, el compartir nativo del teléfono (si lo hay) */
    const native = page.querySelector('[data-share-native]');
    if (native && navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      native.closest('li').hidden = false;
      native.addEventListener('click', () => {
        navigator.share({ title: native.dataset.title, url: native.dataset.url }).catch(() => {});
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-cross"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.recipe-cross--carousel').forEach((root) => {
    const track = root.querySelector('[data-recipe-track]');
    const prev = root.querySelector('[data-recipe-prev]');
    const next = root.querySelector('[data-recipe-next]');
    if (!track || !prev || !next) return;
    const step = () => {
      const item = track.querySelector('.recipe-cross__item');
      return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    /* Las flechas se apagan en los extremos; si todo cabe, se esconden */
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      root.querySelector('.recipe-cross__nav').hidden = max <= 0;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ribbon-divider"] && !Shopify.designMode) return;
  try {
    
  /* Las frases corren solas, despacio, de izquierda a derecha (el sentido de
     lectura), y el scroll las acelera: deriva continua + un empujon
     proporcional a la velocidad del scroll que se apaga solo. Hacia arriba,
     frena o retrocede un momento. El offset da la vuelta cada «una tanda» de
     frases y, como el texto es esa tanda repetida, el salto no se ve.
     Solo se anima en pantalla, y nada con motion reducido. */
  (() => {
    /* Colores de los vecinos. Manda la SUPERFICIE que cada modulo declara
       (.surface), como en la onda: arriba, la ULTIMA del modulo anterior (su
       borde inferior); abajo, la PRIMERA del siguiente. */
    const surfaceOf = (section, edge) => {
      if (!section) return null;
      const list = [...section.querySelectorAll('.surface')];
      const el = edge === 'bottom' ? list[list.length - 1] : list[0];
      if (!el) return null;
      const cs = getComputedStyle(el);
      const bg = cs.backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
      /* Hay modulos cuya superficie no pinta la seccion sino un hijo (la
         historia lo pone en su carril): entonces vale el rol que declara la
         superficie, no su fondo transparente, que caia al blanco de reserva */
      return cs.getPropertyValue('--color-surface').trim() || null;
    };
    const paint = () => {
      document.querySelectorAll('.ribbon').forEach((ribbon) => {
        const wrap = ribbon.closest('.shopify-section') || ribbon.parentElement;
        const above = surfaceOf(wrap.previousElementSibling, 'bottom');
        const below = surfaceOf(wrap.nextElementSibling, 'top');
        if (above) ribbon.style.setProperty('--ribbon-above', above);
        if (below) ribbon.style.setProperty('--ribbon-below', below);
      });
    };
    paint();
    document.addEventListener('shopify:section:load', paint);
    document.addEventListener('shopify:section:reorder', paint);

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* px/s en reposo: token --motion-ribbon-speed (30/09/2026: 40, «un poco
       más rápida»; antes 28 fijo) */
    const BASE = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion-ribbon-speed')) || 40;
    const BOOST = 0.6; /* cuanto empuja cada px/s de scroll */
    const DECAY = 0.92; /* por frame: el empujon se apaga en ~0,5 s */

    document.querySelectorAll('[data-motion="ribbon"]').forEach((ribbon) => {
      const tp = ribbon.querySelector('textPath');
      const text = ribbon.querySelector('text');
      if (!tp || !text) return;
      const repeats = Number(ribbon.dataset.repeats) || 4;
      const measure = () => text.getComputedTextLength() / repeats;
      let loop = measure();
      document.fonts.ready.then(() => { loop = measure(); });

      let offset = 0;
      let push = 0;
      let lastY = scrollY;
      let last = performance.now();
      let visible = false;
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }).observe(ribbon);

      const tick = (now) => {
        const dt = Math.min((now - last) / 1000, 0.1);
        last = now;
        const dy = scrollY - lastY;
        lastY = scrollY;
        push = push * DECAY + (dt > 0 ? dy / dt : 0) * BOOST * (1 - DECAY);
        if (visible && loop > 0) {
          offset += (BASE + push) * dt;
          offset = ((offset % loop) - loop) % loop;
          tp.setAttribute('startOffset', offset.toFixed(1));
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snack-bar"] && !Shopify.designMode) return;
  try {
    
  // El marquee necesita dos cosas que el CSS no sabe: cuantas copias hacen
  // falta para tapar el viewport, y cuanto dura una vuelta para que la
  // velocidad sea la misma tanto si hay tres mensajes como si hay diez.
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function build(track) {
      // Limpiar los clones de una pasada anterior (resize, editor de Shopify)
      track.querySelectorAll('[data-snack-clone]').forEach(function (el) {
        el.remove();
      });

      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length || reduced.matches) return;

      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      // Ancho de UN grupo, contando el hueco que lo separa del siguiente
      var groupWidth = originals.reduce(function (sum, el) {
        return sum + el.getBoundingClientRect().width + gap;
      }, 0);
      if (groupWidth <= 0) return;

      // Copias hasta cubrir el viewport y una de reserva, que es la que entra
      // por la derecha mientras la original sale por la izquierda.
      var needed = Math.ceil(track.parentElement.offsetWidth / groupWidth) + 2;
      for (var i = 0; i < needed; i++) {
        originals.forEach(function (el) {
          var clone = el.cloneNode(true);
          clone.setAttribute('data-snack-clone', '');
          // ⚠️ El clon NO se lee: el lector de pantalla ya ha leido el
          // original, y repetirlo cuatro veces es ruido, no contenido.
          clone.setAttribute('aria-hidden', 'true');
          // Y tampoco recibe foco ni identidad del editor de Shopify
          clone.removeAttribute('id');
          track.appendChild(clone);
        });
      }

      // Velocidad constante en px/s: la duracion sale del ancho, no al reves.
      var speed = parseFloat(track.getAttribute('data-snack-speed')) || 60;
      track.style.setProperty('--snack-shift', groupWidth + 'px');
      track.style.animationDuration = groupWidth / speed + 's';
      track.setAttribute('data-snack-ready', '');
      drift(track, groupWidth, speed);
    }

    // ⭐ El movimiento de la BANDANA (30/09/2026, validado en el prototipo de
    // La Newyorkina v2): corre de izquierda a derecha, en el sentido de
    // lectura; en reposo a la velocidad del editor, y el scroll la ACELERA con
    // un empujon que se apaga solo. Se para con el raton o el foco encima (una
    // frase que huye no se lee). Sustituye a la animacion CSS, que se queda
    // como respaldo sin JS (data-snack-js la apaga).
    var BOOST = 0.6; // cuanto empuja cada px/s de scroll
    var DECAY = 0.92; // por frame: el empujon se apaga en ~0,5 s
    function drift(track, group, base) {
      track.setAttribute('data-snack-js', '');
      var state = track._snack || (track._snack = { x: 0, push: 0, hold: false });
      state.group = group;
      state.base = base;
      if (state.running) return;
      state.running = true;
      var bar = track.closest('.snack-bar') || track.parentElement;
      var hold = function (on) { return function () { state.hold = on; }; };
      bar.addEventListener('mouseenter', hold(true));
      bar.addEventListener('mouseleave', hold(false));
      bar.addEventListener('focusin', hold(true));
      bar.addEventListener('focusout', hold(false));
      var lastY = window.scrollY;
      var last = performance.now();
      var tick = function (now) {
        var dt = Math.min((now - last) / 1000, 0.1);
        last = now;
        var dy = window.scrollY - lastY;
        lastY = window.scrollY;
        state.push = state.push * DECAY + (dt > 0 ? Math.abs(dy) / dt : 0) * BOOST * (1 - DECAY);
        if (state.group > 0 && !state.hold) {
          state.x = (((state.x + (state.base + state.push) * dt) % state.group) + state.group) % state.group;
          track.style.transform = 'translateX(' + (state.x - state.group).toFixed(1) + 'px)';
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    function init() {
      document.querySelectorAll('[data-snack-track]').forEach(build);
    }

    // Las fuentes cambian el ancho de los mensajes, y la Explorer carga con
    // `swap`: medir antes de que llegue deja el bucle descuadrado.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(init);
    } else {
      init();
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 200);
    });

    // El editor de Shopify recarga secciones sin recargar la pagina
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["status"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-status]').forEach((root) => {
      const chips = [...root.querySelectorAll('[data-status-filter]')];
      const items = [...root.querySelectorAll('[data-status-item]')];
      const groups = [...root.querySelectorAll('[data-status-group]')];
      const total = root.querySelector('[data-status-total]');
      if (!chips.length || !items.length) return;

      const matches = (item, filter) => filter === 'all' || item.dataset.state === filter;

      // Los recuentos de los chips salen de lo que hay pintado, no de un número aparte
      chips.forEach((chip) => {
        const count = items.filter((item) => matches(item, chip.dataset.statusFilter)).length;
        const badge = chip.querySelector('[data-status-count]');
        if (badge) badge.textContent = count;
        chip.disabled = count === 0;
      });

      const apply = (filter) => {
        chips.forEach((chip) => {
          const on = chip.dataset.statusFilter === filter;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', String(on));
        });

        let visible = 0;
        items.forEach((item) => {
          const show = matches(item, filter);
          item.hidden = !show;
          if (show) visible += 1;
        });

        // Un grupo sin nada que enseñar se va con su encabezado
        groups.forEach((group) => {
          const shown = group.querySelectorAll('[data-status-item]:not([hidden])').length;
          group.hidden = shown === 0;
          const count = group.querySelector('[data-status-group-count]');
          if (count) count.textContent = shown;
        });

        if (total) {
          const noun = visible === 1 ? 'punto' : 'puntos';
          total.textContent = filter === 'all' ? `${visible} ${noun}` : `${visible} ${noun} de ${items.length}`;
        }
      };

      root.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-status-filter]');
        if (!chip || chip.disabled) return;
        apply(chip.dataset.statusFilter);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"]) return;
  try {
    

  /* ⭐ EL MENÚ DEL BOTÓN ÚNICO: abre y cierra (Esc y clic fuera también), y
     enseña Reseñas y Cookies solo si su app ha pintado su botón, que es lo que
     nuestro menú pulsa por debajo. Las apps cargan tarde: se mira al abrir. */
  document.querySelectorAll('[data-sticky-menu]').forEach((root) => {
    /* Ocultar los flotantes de las apps (los pulsa este menú). Las apps los
       pintan tarde y a veces los repintan: se vigila el DOM. !important porque
       las apps usan estilos en línea. */
    const hideList = [root.dataset.stickyHide]
      .concat([...root.querySelectorAll('[data-sticky-proxy]')].map((o) => o.dataset.stickyProxy))
      .filter(Boolean)
      .join(',');
    const hideApps = () => {
      if (!hideList) return;
      try {
        document.querySelectorAll(hideList).forEach((el) => {
          if (!root.contains(el)) el.style.setProperty('display', 'none', 'important');
        });
      } catch (e) { /* selector mal escrito en el editor: no rompe nada */ }
    };
    hideApps();
    new MutationObserver(hideApps).observe(document.body, { childList: true, subtree: true });

    const toggle = root.querySelector('[data-sticky-toggle]');
    const menu = root.querySelector('.sticky-cta__menu');
    if (!toggle || !menu) return;
    const setOpen = (open) => {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
      if (open) menu.querySelector('li:not([hidden]) .sticky-cta__option')?.focus();
    };
    toggle.addEventListener('click', () => setOpen(menu.hidden));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) { setOpen(false); toggle.focus(); }
    });
    document.addEventListener('click', (event) => {
      if (!menu.hidden && !root.contains(event.target)) setOpen(false);
    });
    /* ⭐ NO TAPAR: el botón se aparta cuando un control queda debajo de él.
       El observador mira SOLO la esquina que ocupa el botón (rootMargin
       recorta la pantalla a esa caja, con un poco de aire), así que el
       navegador avisa justo cuando algo entra o sale de ahí: nada de medir en
       cada scroll. Con el menú abierto o el foco dentro no se mueve —se está
       usando—. Lo que hay dentro de un <dialog> no cuenta: va por encima. */
    const AVOID = 'button, .button, input, select, textarea, [role="button"], .shopify-payment-button, [data-sticky-avoid]';
    const AIR = 8;
    /* Solo en móvil: en escritorio el botón no se mueve de su esquina */
    const narrow = window.matchMedia('(max-width: 749px)');
    const under = new Set();
    let corner = null;
    const settle = () => {
      const busy = !menu.hidden || root.contains(document.activeElement);
      root.classList.toggle('is-away', under.size > 0 && !busy);
    };
    const watch = () => {
      if (corner) corner.disconnect();
      under.clear();
      /* Se mide sin el desplazamiento de «apartado», o la caja saldría corrida */
      root.classList.remove('is-away');
      const box = toggle.getBoundingClientRect();
      if (!box.width || !narrow.matches) return;
      const top = Math.max(0, Math.round(box.top - AIR));
      const left = Math.max(0, Math.round(box.left - AIR));
      corner = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) under.add(entry.target);
          else under.delete(entry.target);
        });
        settle();
      }, { rootMargin: `-${top}px 0px 0px -${left}px` });
      document.querySelectorAll(AVOID).forEach((el) => {
        if (el.closest('[data-sticky-menu], [data-sticky-ignore], dialog, .shopify-section-group-header-group')) return;
        corner.observe(el);
      });
    };
    watch();
    let resizing = null;
    window.addEventListener('resize', () => {
      if (resizing !== null) return;
      resizing = requestAnimationFrame(() => { resizing = null; watch(); });
    });
    root.addEventListener('focusout', () => setTimeout(settle, 0));
    new MutationObserver(settle).observe(menu, { attributes: true, attributeFilter: ['hidden'] });

    /* Una opción elegida cierra el menú (la app abre su panel encima) */
    menu.addEventListener('click', (event) => {
      if (event.target.closest('.sticky-cta__option')) setTimeout(() => setOpen(false), 0);
    });
    /* Regalo: el popup de Klaviyo se abre con su API (`openForm`). Con las
       cookies rechazadas Klaviyo puede estar cargado y aun así no pintar el
       formulario: si al poco no ha salido nada, se baja al formulario de
       newsletter del pie, que es el href. Sin Klaviyo, el href sin más. */
    const KLAVIYO_WAIT = 1200;
    const klaviyoShown = () =>
      [...document.querySelectorAll('[class*="kl-private-reset-css"]')].some((el) => {
        const box = el.getBoundingClientRect();
        return box.width > 200 && box.height > 200;
      });
    menu.querySelectorAll('[data-klaviyo-form]').forEach((option) => {
      option.addEventListener('click', (event) => {
        const onsite = window._klOnsite;
        if (!onsite || typeof onsite.push !== 'function' || !window.klaviyo) return;
        event.preventDefault();
        onsite.push(['openForm', option.dataset.klaviyoForm]);
        setTimeout(() => {
          if (klaviyoShown()) return;
          const fallback = document.querySelector(option.getAttribute('href'));
          if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, KLAVIYO_WAIT);
      });
    });
    /* Reseñas: si su app pintó su botón (oculto), se pulsa por debajo; si
       no, el enlace sigue a su href (las opiniones de la home). */
    menu.querySelectorAll('[data-sticky-proxy]').forEach((option) => {
      option.addEventListener('click', (event) => {
        let target = null;
        try { target = option.dataset.stickyProxy ? document.querySelector(option.dataset.stickyProxy) : null; } catch (e) { target = null; }
        if (target) {
          event.preventDefault();
          (target.querySelector('a, button') || target).click();
          return;
        }
      });
    });
  });

  /* ⭐ THE WITH CLUB = SMILE.IO. El programa de puntos de la tienda es la app
     Smile.io (app embed de Shopify): sus reglas y el canje viven en SU panel.
     Todo enlace con `data-smile-panel` abre ese panel en vez de navegar; el
     valor, si lo lleva, es la pantalla del panel (deep link de Smile, p. ej.
     `points_activity_rules`). Sin Smile instalado —la tienda de desarrollo—
     el enlace sigue a su href (la pagina del club). */
  /* ⭐ RECOMENDAR: el enlace de recomendacion de Smile (i.refs.cc/…) es
     PERSONAL —lleva el codigo del cliente y con el Smile sabe a quien dar los
     puntos—, asi que no se puede escribir en el theme. Se lee del cliente con
     sesion (SmileShopify.customerReady → referral_url) y se guarda AL CARGAR:
     el portapapeles exige que la escritura ocurra en el mismo gesto del clic,
     y esperar a la red dentro del clic lo invalida en Safari.
     Con enlace: en tactil, el menu nativo de compartir; si no, al
     portapapeles con aviso. Sin sesion: el panel de Smile (unirse). Sin
     Smile: el href. */
  let referralUrl = null;
  const loadReferral = () => {
    const ready = window.SmileShopify?.customerReady;
    if (typeof ready !== 'function') return;
    Promise.resolve(ready.call(window.SmileShopify))
      .then((customer) => { referralUrl = customer?.referral_url || customer?.referralUrl || null; })
      .catch(() => {});
  };
  if (document.readyState === 'complete') loadReferral();
  else window.addEventListener('load', loadReferral);
  document.addEventListener('smile-ui-loaded', loadReferral);

  const flash = (trigger, message) => {
    const label = [...trigger.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
    if (!label || !message) return;
    const original = label.textContent;
    label.textContent = message;
    clearTimeout(trigger._smileFlash);
    trigger._smileFlash = setTimeout(() => { label.textContent = original; }, 2400);
  };

  /* WHATSAPP ES NUESTRO: el enlace va a wa.me con el numero del ajuste, sin
     app de chat (Pushdaddy se apago el 13/10). Solo si en el ajuste «Selector
     del boton de WhatsApp» se pega el de una app, se pulsa su boton en vez de
     seguir el enlace; vacio, que es como viene, no se toca nada. */
  document.addEventListener('click', (event) => {
    const chat = event.target.closest('[data-whatsapp-chat]');
    let appButton = null;
    try { appButton = chat && chat.dataset.whatsappChat ? document.querySelector(chat.dataset.whatsappChat) : null; } catch (e) { appButton = null; }
    if (!appButton) return;
    event.preventDefault();
    appButton.click();
  });

  document.addEventListener('click', (event) => {
    const share = event.target.closest('[data-smile-share]');
    if (share && referralUrl) {
      event.preventDefault();
      const touch = matchMedia('(hover: none)').matches;
      if (touch && navigator.share) {
        navigator.share({ url: referralUrl }).catch(() => {});
        return;
      }
      navigator.clipboard?.writeText(referralUrl).then(() => flash(share, share.dataset.smileShare)).catch(() => {});
      return;
    }
    const trigger = event.target.closest('[data-smile-panel]');
    if (!trigger || typeof window.SmileUI?.openPanel !== 'function') return;
    event.preventDefault();
    const deepLink = trigger.dataset.smilePanel;
    window.SmileUI.openPanel(deepLink ? { deep_link: deepLink } : undefined);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-slider"] && !Shopify.designMode) return;
  try {
    
  /* Slider de fotos de story-slider. La foto nueva ENTRA POR ENCIMA de la
     actual con un barrido en el sentido del gesto (siguiente: de derecha a
     izquierda). Marco cuadrado: clip-path inset sobre la <img>. Muelle: se
     anima el rect del clipPath de cada foto. Los puntos son slider-dots
     (LNYSliderDots): el slider los mueve con go(). Sin GSAP o con motion
     reducido, cambio seco. Lo que no es interacción (parallax, entrada)
     vive en assets/lny-motion.js. */
  (function () {
    var setup = function (root) {
      var frame = root.querySelector('[data-story-slides]');
      var controls = root.querySelector('[data-story-controls]');
      if (!frame || !controls || root._storySlider) return;
      root._storySlider = true;
      var isSvg = frame instanceof SVGElement;
      var slides = Array.prototype.slice.call(frame.querySelectorAll(isSvg ? '.story-slider__slide' : '.story-slider__photo'));
      if (slides.length < 2) return;
      var W = 755;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var duration = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion-slider-duration')) || 1100) / 1000;
      var clipRect = function (g) {
        return document.querySelector(g.getAttribute('clip-path').slice(4, -1) + ' rect');
      };
      if (isSvg) slides.forEach(function (g, k) { if (k) clipRect(g).setAttribute('width', 0); });
      var dotsBox = controls.querySelector('[data-slider-dots]');
      var dots = dotsBox && window.LNYSliderDots ? window.LNYSliderDots.attach(dotsBox) : null;
      var current = 0;
      var busy = false;
      /* Si llega otra orden mientras hay un barrido en curso (el scroll puede
         pedir varias seguidas), se guarda la última y se cumple al acabar */
      var pending = null;
      var copies = Array.prototype.slice.call(root.querySelectorAll('.story-slider__copy'));
      var mark = function () {
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
      };
      /* El texto de la foto cambia con ella: el que sale sube y se apaga, el
         nuevo entra desde abajo (al revés si se retrocede) */
      var swapCopy = function (from, to, dir) {
        if (!copies.length) return;
        var out = copies[from];
        var inn = copies[to];
        inn.classList.add('is-active');
        inn.removeAttribute('inert');
        inn.removeAttribute('aria-hidden');
        out.setAttribute('inert', '');
        out.setAttribute('aria-hidden', 'true');
        if (reduce || !window.gsap) {
          out.classList.remove('is-active');
          return;
        }
        gsap.killTweensOf([out, inn]);
        gsap.to(out, { autoAlpha: 0, y: -24 * dir, duration: 0.45, ease: 'power2.in', onComplete: function () { out.classList.remove('is-active'); gsap.set(out, { clearProps: 'all' }); } });
        gsap.fromTo(inn, { autoAlpha: 0, y: 32 * dir }, { autoAlpha: 1, y: 0, duration: 0.7, delay: 0.25, ease: 'power3.out', onComplete: function () { gsap.set(inn, { clearProps: 'all' }); } });
        /* La marca de rotulador del titular (subrayado, círculo…) se dibuja
           al entrar, como en la entrada de títulos: sin esto solo la tenía
           animada la primera foto (Guille, 30/09). Barrido de clip-path de
           izquierda a derecha, el mismo que las marcas de B Corp. */
        var marks = inn.querySelectorAll('.mk svg');
        if (marks.length) {
          gsap.fromTo(marks,
            { clipPath: 'inset(-40% 100% -40% -5%)' },
            { clipPath: 'inset(-40% -5% -40% -5%)', duration: 0.7, delay: 0.75, stagger: 0.12, ease: 'power2.inOut', onComplete: function () { gsap.set(marks, { clearProps: 'clipPath' }); } });
        }
      };
      var go = function (i, dir) {
        var next = (i + slides.length) % slides.length;
        if (busy) { pending = next; return; }
        if (next === current) return;
        var incoming = slides[next];
        if (dots) dots.go(next);
        swapCopy(current, next, dir || (next > current ? 1 : -1));
        var done = function () {
          current = next;
          busy = false;
          mark();
          if (pending !== null && pending !== current) {
            var again = pending;
            pending = null;
            go(again, again > current ? 1 : -1);
          } else {
            pending = null;
          }
        };
        if (reduce || !window.gsap) {
          if (isSvg) {
            clipRect(slides[current]).setAttribute('width', 0);
            clipRect(incoming).setAttribute('x', 0);
            clipRect(incoming).setAttribute('width', W);
          }
          done();
          return;
        }
        busy = true;
        if (isSvg) {
          var outgoing = slides[current];
          frame.appendChild(incoming); /* la nueva se pinta por encima */
          gsap.fromTo(clipRect(incoming), { attr: dir > 0 ? { x: W, width: 0 } : { x: 0, width: 0 } }, {
            attr: { x: 0, width: W }, duration: duration, ease: 'power3.inOut',
            onComplete: function () { gsap.set(clipRect(outgoing), { attr: { width: 0 } }); done(); }
          });
        } else {
          slides.forEach(function (s) { s.style.zIndex = s === slides[current] ? 1 : 0; });
          incoming.style.zIndex = 2;
          gsap.fromTo(incoming,
            { clipPath: dir > 0 ? 'inset(0% 0% 0% 100%)' : 'inset(0% 100% 0% 0%)' },
            { clipPath: 'inset(0% 0% 0% 0%)', duration: duration, ease: 'power3.inOut',
              onComplete: function () { gsap.set(incoming, { clearProps: 'clipPath' }); done(); } });
        }
      };
      /* Con «Avanzar con el scroll» activo, lny-motion pone root._storyJump:
         flechas y puntos MUEVEN EL SCROLL al punto de esa foto, y es el scroll
         el que la cambia; así los dos nunca se desincronizan */
      var ask = function (i, dir) {
        if (root._storyJump) root._storyJump(Math.max(0, Math.min(slides.length - 1, i)));
        else go(i, dir);
      };
      root._storyGo = go;

      /* ⭐ PASE AUTOMATICO CON BARRA (Guille, 02/10). Sustituye al avance por
         scroll en la home (con la inercia del trackpad se comia pasos). Sin
         flechas: el punto activo se estira en un «tubito» que se llena como
         barra de progreso y, al llenarse, pasa a la foto siguiente. EL TIEMPO
         LO LLEVA LA PROPIA ANIMACION CSS (animationend), asi barra y cambio
         de foto no se desincronizan nunca. Corre solo con el slider en
         pantalla (arranca al llegar a el) y se para fuera de ella. Con motion
         reducido no hay pase: puntos normales. */
      var autoplayMs = (parseFloat(root.dataset.storyAutoplay) || 0) * 1000;
      var startAuto = function () {};
      if (autoplayMs && !reduce && dotsBox && 'IntersectionObserver' in window) {
        root.classList.add('is-autoplay');
        root.style.setProperty('--story-autoplay', autoplayMs + 'ms');
        var visible = false;
        var held = false;
        startAuto = function () {
          root.classList.toggle('is-playing', visible && !held);
        };
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          startAuto();
        }, { threshold: 0.3 }).observe(root);
        /* ⚠️ SIN PAUSA AL PASAR EL RATON (Guille, 02/10): al bajar con la
           rueda el cursor se queda justo encima del slider, asi que nunca
           arrancaba. Solo se para fuera de pantalla y con la pestaña oculta. */
        document.addEventListener('visibilitychange', function () { held = document.hidden; startAuto(); });
        dotsBox.addEventListener('animationend', function (e) {
          if (e.animationName === 'story-progress') go(current + 1, 1);
        });
      }

      controls.querySelector('[data-story-prev]').addEventListener('click', function () { ask(current - 1, -1); });
      controls.querySelector('[data-story-next]').addEventListener('click', function () { ask(current + 1, 1); });
      if (dotsBox) dotsBox.addEventListener('slider-dots:select', function (e) {
        ask(e.detail.index, e.detail.index > current ? 1 : -1);
      });
      mark();
    };
    var init = function (scope) {
      (scope || document).querySelectorAll('[data-story-slider]').forEach(setup);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleguide"]) return;
  try {
    
  /* Los botones de prueba de la entrada «Toast»: disparan el mismo evento que
     usaria cualquier modulo. Textos literales, como el resto de esta pagina. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest ? event.target.closest('[data-styleguide-toast]') : null;
    if (!trigger) return;
    const error = trigger.dataset.styleguideToast === 'error';
    document.dispatchEvent(
      new CustomEvent('lny:toast', {
        detail: error
          ? { type: 'error', message: 'No hemos podido añadirlo a la cesta. Inténtalo de nuevo.' }
          : {
              type: 'success',
              message: 'Producto añadido',
              detail: 'Granola Original',
              action: { label: 'Ver cesta', url: '/cart' },
            },
      })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talent-card"] && !Shopify.designMode) return;
  try {
    
  /* Tarjeta que se voltea. Accesible: el botón lleva aria-expanded; al voltear,
     el foco va al primer campo y la cara de detrás se marca `inert` (ni foco
     ni lector). «Volver» y Esc devuelven el foco al botón que la abrió. */
  document.querySelectorAll('.talent-card [data-flip]').forEach(function (card) {
    var front = card.querySelector('[data-flip-front]');
    var back = card.querySelector('[data-flip-back]');
    var open = card.querySelector('[data-flip-open]');
    var close = card.querySelector('[data-flip-close]');
    if (!front || !back || !open || !close) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* La cara de detrás nace inert desde aquí y no desde el Liquid: sin JS no
       hay volteo y el formulario tiene que poder usarse */
    back.inert = true;

    var setFlipped = function (on) {
      card.classList.toggle('is-flipped', on);
      open.setAttribute('aria-expanded', String(on));
      front.inert = on;
      back.inert = !on;
      /* el foco espera a que el giro deje la cara de frente */
      setTimeout(function () {
        var target = on ? back.querySelector('input:not([type=hidden])') || close : open;
        target.focus({ preventScroll: true });
      }, reduce ? 0 : 450);
    };
    open.addEventListener('click', function () { setFlipped(true); });
    close.addEventListener('click', function () { setFlipped(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && card.classList.contains('is-flipped')) setFlipped(false);
    });

    /* Tras enviar (o con error) la página vuelve con el mensaje en la cara de
       detrás: se arranca volteada, que es lo que la persona tiene que ver.
       `form` solo existe dentro del tag form, por eso se decide aquí. */
    var result = back.querySelector('.talent-card__message');
    if (result) {
      card.classList.add('is-flipped');
      open.setAttribute('aria-expanded', 'true');
      front.inert = true;
      back.inert = false;
    }

    /* El nombre del fichero elegido: el input nativo no se ve */
    var file = back.querySelector('input[type="file"]');
    var name = back.querySelector('[data-file-name]');
    if (file && name) {
      var hint = name.textContent;
      file.addEventListener('change', function () {
        name.textContent = file.files.length ? file.files[0].name : hint;
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
